export const TECHNOLOGY_SKILL_MAP = {
  App: [
    "CAS PS Technical",
    "Accenture Life Insurance Platform (ALIP)",
    "Software Product Management",
    "Accenture Benefits Management System",
    "ALIP Life & Annuity Functional",
    "Accenture NewsPage DMS/SFA Technical",
    "ALIP Development",
    "Technical Documentation",
    "CAS Product Engineering Technical",
    "CAS Functional",
    "AHSS Product Suite",
    "Accenture Cloud Trade Promotion Management Technical",
    "Accenture Cloud Retail Execution Technical",
    "Accenture Resources Industry Solutions (ARIS)",
    "Accenture NewsPage DMS/SFA Functional",
    "AFLS Air Cargo Price",
    "AFLS Air Cargo Control",
    "AFLS Air Cargo Flight Planning",
    "AFLS Air Cargo Reservations & Capacity",
    "AFLS Air Cargo Exchange",
    "Accenture Cloud Trade Promotion Management Functional",
    "Accenture Cloud Retail Execution Functional",
    "ALIP Product Configuration",
    "ALIP Business Configuration",
  ],
  Delivery: [
    "Requirements Analysis",
    "Accenture Delivery Methods (ADM)",
    "Accenture Delivery Methods (ADM) Estimators",
    "Development Lifecycle Tools",
    "Project Portfolio Management Tools",
    "System Maintenance",
    "Delivery Excellence",
    "Applications Architecture",
    "Accenture Delivery Methods (ADM) for Program Management",
    "Account Delivery Management",
    "Issue Management",
    "IT Governance",
    "Accenture Delivery Suite",
    "Accenture Manage myEngagements (MME)",
    "Application Design",
    "Infrastructure Program Control Services",
    "Program Project Management",
    "Work Management",
    "Service Excellence",
  ],
  "Delivery_Business Ops": [
    "Business Operation Management",
  ],
  Delivery_PCS: [
    "Program Control Services",
    "Delivery Operations Control",
    "Project Resource Management",
    "Accenture iPC Framework",
  ],
  Delivery_Quality:[
    "Infrastructure Quality Assurance",
    "Six Sigma and Analytics",
    "Software Quality Assurance (SQA)",
    "Service Desk Quality Management",
  ],
  "Delivery_Service mobilization":[
    "Knowledge Management Strategy & Design",
    "Service Transformation Management",
    "Service Management Framework Design and Implementation",
    "IT Infrastructure Operations",
    "Project Management Office (PMO) Mobilization & Run",
    "Service Transition",
  ],
  "Delivery_Solution Arch":[
    "Deal Shaping",
    "AI & Data Solution Architecture",
    "Negotiation",
    "Solution Planning Costing & Pricing",
    "Value Architecture & Realization",
    "Tech Solution Architecture",
    "Solution Architecture",
    "Contract Solution Gap Analysis",
  ],
  Delivery_Tech:[
    "Application Lifecycle Management (ALM)",
    "Critical Incident Management",
    "System Integration Delivery Management",
  ],
  Function:[
    "Account Management",
    "Clinical Data Management",
    "Learning Strategies",
    "Market Intelligence",
    "Supply Chain Network Design",
    "Transportation Management Systems (TMS)",
    "Data Analysis & Interpretation",
    "Workforce Analytics",
    "Knowledge Management Administrative Process Design",
    "Content Management",
    "Learning Pathways",
    "Learning Content Development",
    "Learning Delivery Operations",
    "Learning Delivery Strategy",
    "Software Licensing and Pricing",
    "Manufacturing Strategy and Planning",
    "Attendance Management",
    "Pharmacovigilance & Drug Safety Surveillance",
    "Accounts Payable Processing",
    "Recruitment Process Design",
    "Opportunity Management",
    "Sales Pipeline Management",
    "Sales Planning & Forecasting",
    "Developing Proposals",
    "Sales Pursuit Management",
    "Training and Performance Support",
    "Procurement Outsourcing Solution Design",
    "Procurement Strategy and Planning",
    "Inventory Optimization Analytics",
    "Production Planning and Scheduling",
    "Sales and Operations Planning (S&OP)",
    "Business Performance Management",
    "Product Development Strategy",
    "Strategic Workforce Planning",
    "Workforce Scheduling",
    "Event Management",
    "Communications Development and Delivery",
    "Marketing Research Analysis",
    "Leadership Strategies",
    "HR Delivery Strategy",
    "Leadership Development",
    "Budgeting and Forecasting",
    "Marketing Operations",
    "Value Analysis and Prioritization",
    "eCommerce Design & Development",
    "E-Commerce Operations",
    "HR Process Design",
    "Billing Processing",
    "Campaign Management",
    "Credit Management & Assessment",
    "Customer Satisfaction",
    "Customer Interaction Management",
    "Customer Service Management",
    "Enterprise Architecture Strategy",
    "Financial Management",
    "Financial Analysis",
    "Financial Management Reporting",
    "Fixed Asset Accounting",
    "General Ledger Reconciliations",
    "Marketing Process & Operations",
    "Operational Strategies",
    "Order to Cash (OTC)",
    "Payment Processing Design",
    "Performance Measurement Analysis and Improvement",
    "Regulatory Accounting",
    "Risk Management",
    "Sarbanes-Oxley Act (SOX)",
    "Service Operations",
    "Tax Accounting",
    "Business Transformation",
    "Usability Design",
    "Vendor Management",
    "Enterprise Voice & Video Infrastructure",
    "Website Analytics",
    "Digital Marketing",
    "Capital Markets Audit",
    "Capital Markets Research",
    "Social Media CRM",
    "Customer Master Data Management",
    "Leads Management",
    "Asset Management",
    "Process Improvements",
    "Product and Market Strategy",
    "Property and Casualty Insurance",
    "Sustainability Strategy",
    "Pricing Analytics and Modelling",
    "Learning Management Systems (LMS)",
    "Lean Six Sigma Implementations",
    "Order Management",
    "Resource Capacity Forecasting & Planning",
    "Process Innovation",
    "Product Development Management",
    "Talent Management",
    "Business Process Implementation",
    "Anti-Money Laundering (AML)",
    "Commodity Trading Risk Management",
    "Risk Analytics Modelling and Reporting",
    "Asset and Liability Management (ALM)",
    "Technology Risk Management",
    "Visual Communications",
    "Workplace Solutions",
    "Contract Management",
    "CRM Architecture",
    "Digital Marketing Solution",
    "eCommerce Strategy",
    "Customer Journey Mapping",
    "Content Planning & Distribution Strategy",
    "Social Media Strategies",
    "Metrics and Predictive Analytics",
    "Interaction Design",
    "Visual Design Production Guides",
    "Research and Development Operations",
    "Retail Consumer Experience Strategy",
    "Retail Digital Strategy",
    "Service Delivery",
    "Business Design",
    "BI Strategy",
    "Communications Strategy",
    "Commercial Loan Origination",
    "Sales and Channel Management",
    "Sales Renewals Management",
    "AAAP (Accenture Advanced Analytics Platform)",
    "Predictive Modeling and Analytics",
    "Reporting Design & Development",
    "Aftermarket Strategy",
    "Talent Supply Demand Forecast",
    "Insurance Distribution",
    "Fraud Data & Analytics",
    "CRM Application Functional Integration",
    "Data Audit and Profiling",
    "Data Center Facility Design",
    "Estimation and Planning",
    "Infrastructure Design",
    "Infrastructure Planning",
    "MES Mining",
    "SOA Diagnostic",
    "User Research",
    "Linux Operations",
    "Architectural Design",
    "CMT Analytics",
    "Digital Content Solution",
    "Application Architecture Implementation & Test",
    "Supplier Contract Management",
    "Service Desk Voice Support",
    "Service Desk Non-Voice Support",
    "Service Desk ID Administration",
    "Service Desk Knowledge Management",
    "Business Continuity and Disaster Recovery (BCDR)",
    "Accounting & Financial Reporting Standards",
    "Retail Marketing",
    "Sales Distribution and Marketing Strategy",
    "Functional Sizing and Analysis",
    "Learning Process Design",
    "Banking and Treasury law",
    "Account Sales Planning",
    "Banking Architecture Asset",
    "Visual Design",
    "Telecom Order Management",
    "Operations Process Design and Implementation",
  ],
  "Functions_CFO&EV":[
    "EPM Strategy & Roadmap",
    "Financial Processes",
    "Regulatory Compliance",
    "Reporting Analytics",
    "Finance Application Roadmap & Strategy",
  ],
  "Functions_Cloud Customer Experience":[
    "Customer Technical Support",
  ],
  Functions_Customer:[
    "Channel Analytics",
    "Customer Analysis and Segmentation",
    "Customer Experience Design",
    "Marketing Analytics and Reporting",
    "Service Analytics",
    "Customer Service Operations",
    "Accenture Solutions.AI - Customer Engagement",
    "Accenture Solutions.AI - IRG / B2B Growth",
  ],
  "Functions_HP T&O":[
    "Cornerstone Talent Management Suite",
    "Learning Analytics",
    "Learning Assessments",
    "Candidate Relationship Management",
    "HR Technology Strategy",
    "HR Software Selection Processes",
    "Human-Centered Design",
    "HR Analytics",
    "Human Centric Talent and HR Process Design",
    "Workforce Experience Analytics",
    "Learning IT Landscape",
  ],
  "Functions_SC&O":[
    "Sourcing and Procurement Strategy",
    "Supply and Demand Planning",
    "Ivalua",
    "Zycus eSourcing Software",
    "Jaggaer eProcurement Software",
    "Jaggaer Advantage",
    "Jaggaer Direct",
    "Jaggaer Indirect",
  ],
  "IE_Cloud Operations":[
    "Cloud Infrastructure",
    "AWS Administration",
    "Google Cloud Platform Administration",
    "Red Hat Openstack Platform Administration",
    "VMWare Cloud Administration",
    "AWS Architecture",
  ],
  "IE_Cloud Transformation":[
    "Red Hat Openstack Cloud Development",
    "Cloud Migration Planning",
    "Cloud Design and Build",
    "Cloud Automation DevOps",
    "Converged Infrastructure",
    "Cloud Strategy and Assessment",
    "Cloud Wave Management",
    "Infrastructure As Code (IaC)",
    "Oracle Cloud Infrastructure Architecture",
    "Hyper Converged Infrastructure",
    "Google Cloud Platform Architecture",
    "Google DBPaaS Migration",
    "Red Hat Cloud Architecture and Design",
    "VMWare vCloud Architecture and Design",
    "AWS DBPaaS Migration",
    "Cloud Move Architecture",
    "Dell PowerEdge",
    "Nvidia Drive AGX",
    "NVIDIA Jetson",
    "NVIDIA NIM",
    "Google Distributed Cloud Edge",
    "Microsoft Azure Stack",
  ],
  "IE_Data Center Operations":[
    "Batch Scheduling Tools & Techniques",
    "Apache ActiveMQ",
    "Oracle Weblogic Application Server Administration",
    "IBM AS /400 Administration",
    "AIX System Administration",
    "SUSE Linux Administration",
    "Oracle Enterprise Linux Administration",
    "Vmware Virtualization Administration",
    "XenServer Virtualization Administration",
    "Linux Containers Administration",
    "Oracle Real Application Clusters (RAC) Administration",
    "MySQL Database Administration",
    "IBM DB2 Database Administration",
    "Sybase Database Administration (DBA)",
    "Teradata Administration",
    "PostgreSQL Administration",
    "EMC Storage Area Network (SAN) Administration",
    "Netapp Storage Area Network (SAN) Administration",
    "Netapp Network Attached Storage (NAS) Administration",
    "HPE SAN Administration",
    "NetWorker Backup Administration",
    "Veritas NetBackup Administration",
    "TSM Backup Administration",
    "Dataprotector Backup Administration",
    "Commvault Backup Administration",
    "Avamar Backup Administration",
    "EMC Data Domain Administration",
    "Zenoss Tools Administration",
    "Micro Focus Operations Manager i",
    "Remedy Administration Tool",
    "Servicenow Tools Administration",
    "TWS Administration",
    "Websphere Application Server & Portal Administration",
    "JBOSS Administration",
    "Apache Administration",
    "Internet Information Server (IIS) Administration",
    "TIBCO Administration",
    "Websphere Portal Server Administration",
    "Flexpod Administration",
    "Exadata Administration",
    "Exalogic Administration",
    "Oracle Solaris",
    "Splunk Administration",
    "Apache Hadoop Administration",
    "BigData Analytics Administration",
    "Nutanix Administration",
    "NoSQL Database Administration",
    "MongoDB Administration",
    "Apache CouchDB Administration",
    "Cassandra Database",
    "Docker Kubernetes Administration",
    "Solarwinds Administration",
    "Zabixx-Nagios Tools Administration",
    "EMT Technical Design & Architecture",
    "Ubuntu Linux Administration",
    "Debian Linux Administration",
    "CentOS Administration",
    "Red Hat OS Administration",
    "Backup and Recovery Systems",
    "NNM Tools Administration",
    "Apache Tomcat Administration",
    "Autosys Administration",
    "Informatica Administration",
    "ControlM Administration",
    "IBM WebSphere MQ & Message Broker Administration",
    "Application Performance Management (APM) Architecture",
    "AppDynamics Administration",
    "Dynatrace Administration",
    "SUSE Linux Architecture",
    "HPUX System Administration",
    "NoSQL Architecture and Design",
    "Distributed Storage Architecture and Design",
    "Splunk Enterprise Architecture and Design",
    "Work Load Automation Architecture and Design",
    "Dell EMC SAN Architecture and Design",
    "NetApp NAS Architecture and Design",
    "Bigdata Analytics Architecture and Design",
    "EMT Administration",
    "Service-Oriented Architecture (SOA) Design",
    "Absyss Visual Business Activity Monitoring (BAM)",
    "Absyss Visual TOM",
    "SAP Sybase IQ",
    "MariaDB",
    "ScienceLogic",
    "SAP MaxDB",
    "Progress Database Administration",
    "Managed File Transfer",
    "Zabbix",
    "Veeam Backup and Replication",
  ],
  "IE_Data Center Transformation":[
    "Database Architecture",
    "NAS Architecture and Design",
    "Storage Area Networks (SAN) Architecture and Design",
    "Unix Architecture and Design",
    "Docker Kubernetes Architecture and Design",
    "Cloud Backup Architecture and Design",
    "Oracle Database Architecture",
    "Nutanix Architecture",
    "Cisco HyperFlex Architecture",
    "VMware Datacenter Virtualization Architecture and Design",
    "Linux Architecture",
  ],
  "IE_Infrastructure Modernization":[
    "Compute Unified Device Architecture (CUDA)",
    "GPU Computing",
    "OpenCL",
    "Apigee Edge",
    "Edge Orchestration",
    "Multi-Access Edge Computing (MEC)",
    "Mesh Networking",
    "Satellite",
    "IoT Core",
    "ISA 95",
    "Message Queuing Telemetry Transport (MQTT)",
    "Purdue Reference Model",
    "Real-Time Operating Systems (RTOS)",
    "Sensor Integration",
    "Sensor Technologies",
    "ZigBee",
    "Data as a Service",
    "Edge Runtime",
    "K3S",
    "MicroK8s",
  ],
  "IE_Microsoft Platform":[
    "Microsoft SQL Server Administration",
    "Microsoft Windows Server Administration",
    "Application Compatibility Testing",
    "Microsoft Exchange Server",
    "Microsoft Hyper-V Server",
    "Microsoft SharePoint Administration",
    "Microsoft 365",
    "Microsoft System Center Operations Manager (SCOM)",
    "Microsoft Endpoint Configuration Manager",
    "Microsoft System Center Virtual Machine Manager (SCVMM)",
    "Microsoft Azure IaaS",
    "Microsoft Intune",
    "Microsoft PowerShell",
    "Microsoft Azure Architecture",
    "Desktop Transformation",
    "Microsoft Azure Windows Virtual Desktop",
    "Microsoft Azure VMWare Solution",
    "SAP Cloud Migration on Azure",
    "Microsoft Teams Infrastructure",
    "Microsoft Azure Infra Transformation",
    "Microsoft Azure Infrastructure as Code (IaC)",
    "Ansible on Microsoft Azure",
    "Microsoft Azure Container Infrastructure",
    "Microsoft Azure Guest OS Administration",
    "Microsoft Azure Databases Infrastructure",
    "Microsoft Azure Hybrid Services",
    "Python on Azure",
    "Microsoft Power Platform Infrastructure",
    "Microsoft SharePoint Online Administration",
    "Microsoft Exchange Online",
    "Microsoft Azure Infrastructure Architecture",
  ],
  "IE_Network Implementation":[
    "Network Security Implementation",
    "Network Infrastructures",
    "Carrier Telecom Networks Implementation",
    "Telecommunications Network Capability",
    "SD-WAN Implementation",
    "Cloud Network Implementation",
    "Contact Center Technology Implementation",
    "Data Center Network Technologies Implementation",
    "Unified Communication and Collaboration Implementation",
    "Software Defined Network Implementation",
    "Wireless Technologies Implementation",
    "5G Core Network Architecture",
    "SD Access Implementation",
    "Cloud Contact Center Implementation",
    "Cloud Unified Communication Implementation",
  ],
  "IE_Network Operations":[
    "Network Operations & Service Management",
    "Tableau Desktop",
    "Network Architecture and Design",
    "Enterprise Network Operations",
    "Video Conferencing Infrastructure",
    "Network Security Management",
    "Network Analytics",
    "Data Center Networking Technologies Operations",
    "Qualys Vulnerability Management",
    "Software Defined Network and Operations",
    "Contact Center Technology Capabilities",
    "SD-WAN Operations",
    "Unified Communication and Collaboration Operations",
    "Network Security Operations",
    "Cloud Network Operations",
    "Wireless Technologies Operations",
    "SD Access Operations",
    "Cloud Contact Center Operations",
    "Cloud Unified Communication Operations",
    "VMware NSX-T Data Center",
  ],
  "IE_Other":[
    "Go-to-Market Strategies",
    "Digital Content Delivery",
  ],
  "IE_Service Desk Management":[
    "Service Desk Management",
  ],
  "IE_Service Integration & Management":[
    "IT Financial Management",
    "Service Integration and Management (SIAM)",
    "Cloud Based Service Management Process Design",
    "End User & Data center IT Asset Mgmt",
    "Software License Management",
    "Configuration Database & CI Management",
    "Infrastructure Service Management",
    "Problem Management",
  ],
  "IE_Service Management Transformation":[
    "ServiceNow Strategic Portfolio Management (SPM)",
    "ServiceNow",
    "ServiceNow ITOM Discovery",
    "ServiceNow ITOM ServiceMapping",
    "ServiceNow Performance Analytics",
    "ServiceNow Hardware Asset Management (HAM)",
    "ServiceNow Software Asset Management (SAM)",
    "HPE Network Management Center",
    "BMC TrueSight Orchestrator",
    "BMC Helix Discovery",
    "ServiceNow IT Operations Management",
    "ServiceNow IT Business Management",
    "ServiceNow Customer Service Management (CSM)",
    "ServiceNow ITOM Event Management",
    "ServiceNow App Engine",
    "ServiceNow Field Service Management",
    "ServiceNow Human Resource Service Management (HR)",
    "ServiceNow Legal Service Delivery (LSD)",
    "Micro Focus Operations Orchestration",
    "ServiceNow IT Service Management",
    "BMC Helix ITSM",
    "BMC TrueSight Operations Management",
    "ServiceNow Configuration Management Database (CMDB)",
  ],
  "IE_Workplace Managed Services":[
    "Symantec Endpoint Encryption",
    "Apple macOS Management",
    "Microsoft Windows Desktop Management",
    "Linux/Unix Desktop Management",
    "VMware Horizon",
    "Citrix Virtual Apps and Desktop Administration",
    "VMware ThinAPP Applications",
    "Symantec Altiris",
    "Application Packaging",
    "HCL Notes",
    "VMware AirWatch",
    "HCL BigFix Suite",
    "Adaptiva OneSite",
    "VMware Workspace ONE",
    "NEXThink",
  ],
  "IE_Workplace Transformation":[
    "Citrix Virtual Apps and Desktop Architecture",
    "Apple macOS Architecture",
    "Workplace Technology Solutions",
    "Deployment Management",
  ],
  "Ind_BA":[
    "Business Requirements Analysis",
  "Business Architecture",
  ],
  "Ind_CMT-Comms & Media":[
    "Amdocs CRM",
    "Oracle Communications Order and Service Management (OSM)",
    "IBM Tivoli Netcool",
    "Telecom Revenue Assurance",
    "Communication Technology",
    "Oracle Communications Service Activation",
    "Oracle Communications Unified Inventory Management (UIM)",
    "Network Engineering Planning and Deployment Solution",
    "Next Generation Video Architecture",
    "5G Wireless Networks & Technologies",
    "SDN NFV Software",
    "Telecommunications Billing",
    "Broadcasting Media",
    "Print Publishing",
    "Service Fulfillment",
    "Service Assurance",
    "Gaming & Gambling Fundamentals",
    "Digital Advertising",
    "Communication Inventory Management Solutions",
    "Communication Order Management Solutions",
    "Communications CRM",
    "Accenture Digital Omni Channel Platform (DOCP)",
    "Accenture Digital Video Solutions",
    "Telco Cloud",
    "Telco Architecture Decoupling",
    "Cisco Network Services Orchestrator (NSO)",
    "SingleView",
  ],
  "Ind_CMT-High Tech":[
    "Consumer Technology",
    "Enterprise Technologies",
    "Semiconductor Equipment Provider",
    "High Tech Solutions",
    "Accenture myConcerto Semiconductors",
    "Accenture myConcerto Ent & Consumer Tech",
    "Semiconductor Design and Development",
  ],
  "Ind_CMT-Software & Platforms":[
    "Geospatial Technologies",
    "Developer Ecosystem",
    "Platform Partner Ecosystem Enablement",
    "Software Design & Solutions",
    "Webscale Trust",
  ],
  "Ind_FS-Banking & Capital Markets":[
    "SAP for Banking",
    "Payments Fundamentals",
    "Calypso (Software)",
    "Transaction Banking",
    "Core Banking",
    "Digital Banking",
    "Consumer Lending",
    "Real Estate Lending",
    "Trade Finance",
    "SmartStream Transaction Lifecycle Management (TLM)",
    "Actimize",
    "Equities",
    "Capital Market Regulator Solutions",
    "Infosys Finacle",
    "Payment Card Issuing",
    "Oracle Flexcube Core Banking",
    "Clear2Pay",
    "Finastra Fusion Global PAYplus (GPP)",
    "Temenos Triple A Plus",
    "Payment Card Acquiring",
    "Oracle Financial Services Analytical Application (OFSAA)",
    "Oracle Banking Platform",
    "Trading Services Front Office",
    "Murex Front Office Finance",
    "Murex Back Office Workflows",
    "Murex Connectivity 2.0",
    "Murex Datamart Reporting",
    "Murex Environment and Configuration Management",
    "Murex MXTest",
    "ACI Payment Systems Base24-EPS",
    "Broadridge Gloss",
    "Investment Banking",
    "Wealth Management Advisory Solutions",
    "Temenos Transact",
    "Private Banking",
    "Accenture Mortgage Cadence",
    "Temenos WealthManager",
    "Derivatives",
    "Finastra Fusion Loan IQ",
    "Capital Markets Regulatory Compliance",
    "Financial Asset Management",
    "Fenergo Client Lifecycle Management Solution",
    "ATOM (Applied Technology and Operations for Markets)",
    "BlackRock Aladdin",
    "Finastra Fusion Trade Innovation (TI+)",
    "InvestCloud",
    "SimCorp Data and Reporting",
    "SimCorp Investment Book for Record (IBOR)",
    "Thought Machine Vault",
    "Zafin Solutions",
    "Equipment Finance and Leasing",
    "Charles River Order & Execution Management OEMS Trading",
    "Asset Servicing",
    "Temenos Transact Development",
    "ACI Universal Payment BASE24-Classic",
    "Fiserv Enterprise Payments Platform",
    "Temenos Quantum UXP",
    "Financial Risk Management (FRM)",
    "Financial Crime & Fraud Management",
    "Adenza ControllerView",
    "Capital Markets Reference Data",
    "Trade Lifecycle Management",
    "Securities Clearing & Settlements",
    "Process Architecture for Banking",
    "Charles River Portfolio Management & Risk Analytics",
    "Charles River Middle Office",
    "Charles River Data and Position Management",
    "Avaloq Wealth",
    "Volante Volpay",
    "Retirement Planning Services",
    "VisionPLUS",
    "Murex MX.3 Platform",
    "Avaloq Script",
    "FIS Commercial Loan Servicing (ACBS)",
  ],
  "Ind_FS-Insurance":[
    "SAP for Insurance Claims Management Property & Casualty",
    "SAP for Insurance Collections & Disbursements",
    "Group Life Insurance",
    "Individual Life Insurance",
    "Business Process IT Alignment",
    "Insurance Claims",
    "Commercial Insurance",
    "Personal Insurance",
    "Reinsurance",
    "Guidewire ClaimCenter",
    "Guidewire PolicyCenter",
    "Guidewire BillingCenter",
    "GuideWire Integration",
    "Guidewire BillingCenter BA",
    "Guidewire BillingCenter QA",
    "Guidewire ClaimCenter BA",
    "Guidewire ClaimCenter QA",
    "Guidewire DataHub",
    "Guidewire PolicyCenter BA",
    "Guidewire PolicyCenter QA",
    "Duck Creek Billing",
    "Duck Creek Policy",
    "Duck Creek Claims",
    "Group Benefits Pensions & Annuities",
    "Guidewire Digital Portals",
    "Duck Creek Data Insights",
    "Duck Creek Architecture",
    "Fineos Insurance Platform",
    "EIS Suite Functional",
    "Vitech V3locity Platform",
    "EIS Suite Technical",
    "Quality Engineering Strategy Implementation",
    "Duck Creek AgencyPortal",
  ],
  "Ind_H&PS-Health":[
    "Cerner",
    "Electronic Medical Records (EMR)",
    "Epic Systems",
    "Health Insurance Operations",
    "State Medicaid",
    "Medicare Advantage",
    "Pharmacy Benefits Management (PBM)",
    "Payer Rating and Underwriting",
    "Payer Portals",
    "Payer Eligibility & Enrollment",
    "Health Level 7",
    "Healthcare Utilization Management",
    "Connected Health",
    "Accenture myConcerto Health Provider",
    "Electronic Health Records (EHR)",
    "Fast Healthcare Interoperability Resources (FHIR)",
    "DICOM Standard",
    "SNOMED CT",
    "Epic Clarity",
    "Epic Clinical Ambulatory",
    "Epic Clinical Ancillary",
    "Epic Clinical Inpatient",
    "Epic EHR",
    "Epic Health Information Management (HIM)",
    "Epic HomeHealth",
    "Epic Infrastructure",
    "Epic Integration",
    "Epic Patient Access",
    "Epic Reporting",
    "Epic Revenue Cycle",
  ],
  "Ind_H&PS-Public Service":[
    "A&D Defense",
    "Education",
    "Social Services Pensions",
    "Social Services Workforce Dev",
    "Government Back Office",
    "Public Safety",
    "Post & Parcel",
    "Public Services",
    "Board International Software",
  ],
  "Ind_PRD-CG&S, Retail, Travel Services":[
    "Oracle Retail Advanced Inventory Planning (AIP)",
    "Oracle Retail Demand Forecasting (RDF)",
    "Oracle Retail Item Planning (IP)",
    "Oracle Retail Merchandise Financial Planning (MFP)",
    "Oracle Retail Merchandising System (RMS)",
    "Oracle Retail Predictive Application Server (RPAS)",
    "Oracle Retail Price Management (RPM)",
    "Oracle Retail Replenishment Optimization",
    "Oracle Retail Sales Audit (ReSA)",
    "Oracle Retail Store Inventory Operation",
    "Sustainable Supply Chain Strategy",
    "Oracle Retail Assortment Planning",
    "Oracle Retail Integration Cloud Services",
    "SAP for Retail",
    "Alcoholic Beverages",
    "Consumer Goods and Services",
    "Consumer Healthcare",
    "Food Companies",
    "Home & Personal Care",
    "Merchandising",
    "Grocery Industry",
    "Nicotine & Beyond",
    "Agribusiness",
    "Retail Industry",
    "eCommerce & Digital Marketplaces",
    "Beauty and Personal Goods",
    "Hotel and Lodging",
    "Aviation IT Solutions",
    "Oracle Retail Xstore Point of Service (POS)",
    "Property Management Systems (PMS)",
    "Amadeus Hospitality Solutions",
    "Travel platform players",
    "Cruise Lines",
    "Amadeus Aviation Solutions",
    "Retail Supply Chain Management",
    "Specialty Retail",
    "Hospitality Reservation Management",
    "Hospitality Loyalty Management",
    "Retail Store Operations",
    "Apparel, Luxury & Accessories",
    "Accenture myConcerto Retail",
    "Accenture myConcerto Travel",
    "Retail Analytics",
    "Trade Promotions Management",
    "Accenture myConcerto Consumer Goods&Services",
    "Relex Platform",
  ],
  "Ind_PRD-Industrials (Incl Auto, A&D)":[
    "Aerospace & Defense (A&D)",
    "SAP Manufacturing Batch Management",
    "SAP Vehicle Management for Automotive",
    "SAP for Automotive",
    "IFS Solutions",
    "Accenture Fare Management Solution (AFMS)",
    "Consumer Durables",
    "eTicketing Solutions",
    "Heavy Equipments",
    "Industrial and Electrical Equipment",
    "Industrial Suppliers",
    "Construction & Infrastructure Solutions",
    "Automotives",
    "Industrial Machinery",
    "Rail and Transit",
    "IFS Solutions Administration",
    "IFS Solutions Functional Management",
    "Freight Logistics",
    "SAP Digital Manufacturing Cloud",
    "Accenture myConcerto Aerospace & Defense",
    "Accenture myConcerto Automotive and IES",
    "Accenture myConcerto Automotive OEM",
    "A&D Aftermarket",
    "A&D Commercial Aerospace",
  ],
  "Ind_PRD-Life Sciences":[
    "TrackWise Quality Management Software",
    "Oracle Argus",
    "Life Sciences R&D",
    "Life Sciences Commercial and Market Services",
    "Life Sciences Supply Chain",
    "Computer System Validation (CSV)",
    "Medical Technology",
    "Life Sciences Validation Testing",
    "Oracle Life Sciences Data Hub (Oracle LSH)",
    "Patient Services",
    "Veeva CRM",
    "Veeva Vault",
    "Life Sciences Revenue Management",
    "Life Sciences Industry",
    "Laboratory Information and Execution Systems",
    "SAP Advanced Track and Trace for Pharmaceuticals",
    "Accenture myConcerto Life Sciences",
  ],
  "Ind_RES-Chemicals & Natural Resources":[
    "Accenture myConcerto Chemicals",
    "Accenture myConcerto Metals",
    "Accenture myConcerto Mining",
    "Metals Sales & Marketing",
    "Metals Supply Chain Planning and Execution",
    "Metals",
    "Mineral Processing Technologies",
    "Mining Value Chain",
    "Mining Planning and Scheduling",
    "SAP for Mining",
    "Chemicals Industry Applications",
    "Agrochemicals & Crop Protection",
    "Intelligent Mine Asset Management",
    "Cement and Aggregates",
    "Aluminum",
    "Copper",
    "Iron & Steel",
    "B2B/B2C Sales",
    "Forestry & Forest Products",
    "ABS Chemical Enterprise Services",
    "Building Materials",
  ],
  "Ind_RES-Energy":[
    "SAP for Oil & Gas Downstream",
    "SAP for Oil & Gas Production and Revenue Accounting",
    "SAP for Oil & Gas Remote Logistics Management",
    "SAP for Oil & Gas Trader's & Scheduler's Workbench",
    "Downstream Non Hydrocarbon Supply Chain",
    "SAP for Oil & Gas Joint Venture Accounting",
    "SAP for Oil & Gas Secondary Distribution",
    "Upstream Non Hydrocarbon Supply Chain",
    "Oil and Gas Production Operations",
    "Oil & Gas Drilling and Completions",
    "Downstream Marketing",
    "Energy",
    "Upstream Energy Fundamentals",
    "Power Trading and Origination",
    "Downstream Retail Technology",
    "Openlink Endur",
    "Openlink RightAngle",
    "Tieto Energy Components",
    "SAP for Oil & Gas Upstream Operations Management",
    "Openlink Endur Functional",
    "Openlink Endur Environment Management",
    "Document Management Systems (DMS)",
    "Historian Applications",
    "Aspen Petroleum Scheduler",
    "Refinery Applications Integration Architecture",
    "Enablon Software Platform",
    "Sphera ORM (Proscient) Platform",
    "Oil and Gas Upstream",
    "Engineering Procurement Construction and Installation",
    "Renewable Energy",
    "Petrochemicals",
    "PLM for Capital Asset Lifecycle Management",
    "Climate Change & Sustainability",
    "Decarbonized Energy Solutions Delivery",
    "Geographic Information Systems (GIS)",
    "Assets Reliability and Maintenance Management",
    "Accenture myConcerto Energy",
    "SAP Field Logistics",
  ],
  "Ind_RES-Utilities":[
    "SAP for Utilities Billing",
    "SAP for Utilities CRM",
    "Oracle Lodestar Functional",
    "Oracle Utilities Customer to Meter C2M SPL",
    "SAP for Utilities Cust Financial Mgt FICA",
    "SAP for Utilities Energy Data Management Device Management",
    "SAP for Utilities InterCompany Data Exchange",
    "Smart Grid Operations & Control Room",
    "Utilities Retail",
    "Grid Enterprise Asset Management EAM",
    "Outage Management Systems (OMS)",
    "Oracle CC&B Technical Architecture",
    "Oracle Utilities Meter Data Management (MDM)",
    "Oracle Utilities Work and Asset Management",
    "Siemens eMeter",
    "Oracle Utilities Lodestar Technical",
    "Oracle Utilities Lodestar Technical Architecture",
    "Meter Data Management",
    "Smart Grid Work Field and Resource Management Solutions",
    "Oracle Utilities Testing Accelerator",
    "Powercloud Platform",
    "Accenture myConcerto Utilities ERCS",
    "Accenture myConcerto Utilities T&D",
  ],
  "invalid skill":[
    "Talent Pipeline",
  ],
  "Language":[
    "Norwegian Language",
    "Thai Language",
    "Mandarin Chinese Language",
    "Spanish Language",
    "Portuguese Language",
    "German Language",
    "Japanese Language",
    "French Language",
    "Dutch Language",
    "Italian Language",
    "Finnish Language",
    "English Language",
  ],
  "No owner":[
    "CRM Applications",
    "Varicent",
    "SABA Talent Management Solutions",
    "Apache CXF",
    "Adobe ColdFusion",
    "Continuous Integration (CI) Tools",
    "Eclipse Business Intelligence Reporting Tools (BIRT)",
    "Enterprise Security Architecture (ESA) Fundamentals",
    "Hitachi Data Systems (HDS)",
    "IBI WebFocus",
    "NetApp Data Management & Cloud Storage Solutions",
    "Quest TOAD",
    "SAP ASE (Sybase) RDBMs",
    "SAP PowerBuilder",
    "Abacus Configuration & Implementation",
    "Broadcom Clarity PPM",
    "PRINCE2",
    "Objective-C (Programming Language)",
    "Technology Solution Estimating",
    "Server Virtualization Tools",
    "SOA Strategy",
    "Apttus Solutions",
    "The Open Group Architecture Framework (TOGAF)",
    "Customer Value Proposition Development",
    "Micro Focus Mobile Testing",
    "jQuery UI",
    "Human Capital Management Applications",
    "Talend Data Catalog Solutions",
  ],
  "Sec_Application Security":[
    "Application Vulnerability Management Operations",
    "Application Security Architecture and Design",
    "API Security",
    "Application Security",
  ],
  "Sec_Cloud First Security":[
    "Computer Security Incident Response",
    "Endpoint Protection",
    "Symantec Endpoint Protection (SEP)",
    "Cloud Security Planning",
    "Cloud Security Architecture",
    "Amazon Web Services (AWS) Security",
    "Cisco Firewall",
    "Palo Alto Networks Firewalls",
    "Managed Cloud Security Services",
    "Checkpoint Next Generation Firewall",
    "McAfee Endpoint Protection",
    "Web Application Firewall (WAF)",
    "Host Intrusion Protection Operations",
    "Cloud Access Security Broker (CASB)",
    "Zscaler Architecture",
    "Amazon Cognito",
    "Cisco Identity Services Engine (ISE)",
    "Fortinet FortiGate Firewall",
    "Firewall Architecture",
    "Barracuda Firewall",
    "Palo Alto Networks Prisma Access Secure Access Service Edge (SASE)",
    "Transmit Security Software",
  ],
  "Sec_Cyber Industry":[
    "Operational Technology (OT) Security",
    "Internet of Things (IoT) Security",
    "SDV Product Security",
    "Product Security",
    "Supervisory Control and Data Acquisition (SCADA) Security",
    "Hardware Security",
    "Medical Device Security",
    "Connected Device Security",
  ],
  "Sec_Cyber Readiness":[
    "Static Application Security Testing (SAST)",
    "Web Application Security Testing",
    "Enterprise Application Security Design and Testing",
    "Mobile Security",
    "Web Services Security",
    "Dynamic Application Security Testing (DAST)",
    "Mobile Security Testing",
    "Security Penetration Testing",
    "DevSecOps",
    "Infrastructure Penetration Testing",
    "Cloud Security Penetration Testing",
    "Network Penetration Testing",
    "AI Penetration Testing",
    "Red Teaming",
    "CrowdStrike Continuous Threat Exposure Management (CTEM)",
  ],
  "Sec_Cyber Risk & Regulatory":[
    "Governance Risk Compliance (GRC)",
    "ServiceNow Governance, Risk, and Compliance (GRC)",
    "Governance Risk and Compliance (GRC) Platforms",
    "Security Risk and Audit Operations",
    "Governance Risk & Compliance (GRC) Platform Operations",
    "Governance Risk & Compliance (GRC) Tools",
    "Integrated Security Risk Management",
    "RSA Archer Platform Administration",
    "Business Continuity Planning (BCP)",
    "Third Party IT Risk Management",
    "Security Compliance Management",
    "Industrial Cybersecurity Standard ISA 62443",
    "Industrial Cybersecurity Standard NIST 800-8241",
    "Operational Technology (OT) Security Assessment Program Development",
    "Operational Technology (OT) Security Processes and Procedures",
    "Operational Technology (OT) Security Program Development",
    "Operational Technology (OT) Security Strategy",
  ],
  "Sec_Data & AI Security":[
    "Data Loss Prevention (DLP)",
    "Data Privacy Protection",
    "Data Masking",
    "Data Encryption",
    "End User Data Privacy",
    "Security Data Privacy",
    "Google Cloud Identity Platform",
    "Post-Quantum Cryptography",
    "Database Activity Monitoring",
  ],
  "Sec_Detection & Response":[
    "Infrastructure Security Vulnerability Management Operations",
    "Forensic Analysis",
    "Cyber Threat Intelligence",
    "Malware Reverse Engineering",
    "Security Information and Event Management (SIEM)",
    "Splunk Security Information and Event Management (SIEM)",
    "Security Breach Response Operations",
    "Security Threat Hunting",
    "Accenture Managed Detection & Response (MDR) Platform",
    "Palo Alto Cortex XSOAR",
    "Security Operation Automation",
    "Accenture MxDR Ops Security Engineering",
    "Accenture MxDR Ops Security Threat Analysis",
    "Endpoint Extended Detection and Response",
    "Google Chronicle SIEM",
    "Google Chronicle SOAR",
    "Security Platform Engineering",
    "CrowdStrike Next-Gen SIEM",
    "CrowdStrike Falcon    ",
    "CrowdStrike Endpoint Security",
  ],
  "Sec_Identity & Access Management":[
    "Oracle Identity Manager (OIM)",
    "SailPoint IdentityIQ",
    "Oracle Access Manager",
    "CyberArk Privileged Access Management",
    "ForgeRock Access Management",
    "ForgeRock Identity Management",
    "SailPoint IdentityNow",
    "Identity and Access Management (IAM) Operations",
    "Broadcom Symantec SiteMinder",
    "IBM Tivoli Access Manager",
    "IBM Tivoli Identity Manager",
    "Okta Identity Management",
    "Identity Access Management (IAM)",
    "IAM Technical Architecture and Design",
    "Ping Identity",
    "Saviynt Identity Platform",
    "One Identity Manager",
    "Omada Identity Cloud",
    "Delinea Software",
    "Secure AI",
    "BeyondTrust Privileged Access Management",
    "HashiCorp Vault",
    "Venafi Machine Identity Access Management",
  ],
  "Sec_Platform Security":[
    "Oracle Governance Risk and Compliance (GRC)",
    "Oracle Cloud GRC Configuration Controls",
    "SAP Security",
    "Salesforce Security",
    "Oracle Fusion Applications Security",
    "Oracle Advanced Financial Controls",
    "Oracle Advanced HCM Controls",
    "Oracle Financial Reporting Compliance Cloud",
    "Oracle Advanced Access Controls",
  ],
  "Sec_Security Enablement":[
    "Security Solution Development",
    "Security Quality Assurance",
    "Security Delivery Governance",
  ],
  "Sec_Security Strategy & Organization":[
    "Cybersecurity Strategy Development",
    "Security Strategy & Planning",
    "Security Architecture Design",
    "Security Metrics Development",
    "Cybersecurity Fundamentals",
    "Security Strategy Transformation",
    "Security Governance",
  ],
  "Tech_Adobe Platform":[
    "Adobe Marketo Engage",
    "Adobe InDesign",
    "Adobe Experience Manager (AEM) Sites",
    "Adobe Campaign Classic",
    "Adobe Target",
    "Adobe Analytics",
    "Adobe XD",
    "Adobe Audience Manager",
    "Adobe Experience Cloud",
    "Adobe Workfront Work Management Software",
    "Adobe Substance Painter",
    "Adobe Experience Platform (AEP)",
    "Adobe Sign",
    "Adobe Magento Commerce",
    "Adobe Experience Manager (AEM) UI Development",
    "Adobe Journey Optimizer",
    "Adobe Substance 3D Designer",
  ],
  "Tech_Agile":[
    "Operating Model Development",
    "Agile Process Coaching",
    "Atlassian Confluence",
    "Agile Program Management",
    "Atlassian JIRA",
    "Atlassian Bamboo",
    "Scaled Agile Framework (SAFe)",
    "Agile Project Management",
    "Agile Technical Coaching",
    "Agile Requirement Management",
    "Atlassian Trello",
    "Atlassian Jira Align",
    "Atlassian Jira Service Desk",
    "Atlassian Jira Xray",
    "Atlassian Jira Zephyr",
    "Business Agility",
    "IT4IT Reference Architecture",
    "Atlassian Cloud Architecture",
    "Target Operating Model (TOM)",
  ],
  "Tech_Application Modernization":[
    "Application Portfolio Optimization (APO)",
    "Application Remediation",
    "Mainframe Application Performance Optimization",
    "Service Oriented Architecture (SOA)",
    "Micro Focus COBOL",
    "Decommissioning Analysis",
    "Application Replatforming Fundamentals",
    "Application Migration",
    "Application Modernization",
    "Application Portfolio Planning",
    "Low Code Application Development",
  ],
  "Tech_Arch Integration":[
    "TIBCO BusinessWorks",
    "webMethods Business Process Management Suite (BPMS)",
    "API Management",
    "Axway Specialized Tools",
    "Boomi Atomsphere Integration",
    "Microservices and Light Weight Architecture",
    "Axway API Management Platform",
    "Mashery API Management",
    "Service Mesh Architecture",
    "Confluent Event Streaming Platform",
    "Axway B2B Integration",
  ],
  "Tech_Artificial Intelligence":[
    "Natural Language Processing (NLP)",
    "Machine Learning",
    "Virtual Agents",
    "Computer Vision",
    "Kofax Intelligent Automation Platform",
    "Machine Learning Operations",
    "Prompt Engineering",
    "Conversational AI",
    "GCP - Vertex AI",
    "Large Language Models (LLMs)",
    "Responsible AI",
    "Google Cloud Vertex AI Model Development",
    "AI Agents & Workflow Integration",
    "Generative AI",
    "Retrieval-Augmented Generation",
  ],
  "Tech_ATA":[
    "Accenture Delivery Architectures (ADA)",
    "Integration Architecture Blueprint & Design Solutions",
  ],
  "Tech_Automation":[
    "Automation Advisory",
    "Automation in Application Maintenance",
    "Automation in Application Development",
    "Automation in Systems Integration",
    "Infrastructure Automation",
    "Automation Architecture",
  ],
  "Tech_AWS":[
    "AWS Management Console",
    "Amazon Elastic Compute Cloud (Amazon EC2)",
    "AWS CloudFormation",
    "Amazon Web Services (AWS)",
    "AWS Elastic Beanstalk",
    "AWS Core Infrastructure",
    "AWS Billing",
    "AWS Operations",
    "AWS High Availability",
    "Amazon Alexa",
    "AWS Lambda Administration",
    "AWS Outposts",
    "AWS AI Services",
    "AWS Compute",
    "AWS Governance",
    "AWS Storage Database",
    "AWS Migration Transfer",
    "AWS Containerization",
    "AWS Machine Learning",
    "AWS Analytics",
    "AWS Application Integration",
    "AWS Media Services",
    "AWS Mainframe Modernization",
    "Amazon Connect",
    "AWS Networking",
    "OpenSearch",
  ],
  "Tech_BPM Solutions":[
    "BPM Strategy & Solutions",
    "Business Process Design",
    "Software AG ARIS Express",
    "Business Process Modeling Notation (BPMN)",
    "Business Process Analysis Tools",
    "Business Process Modeling",
    "Bizagi Modeler",
    "Signavio Process Editor",
    "ARIS Product",
    "Business Process Management (BPM)",
    "Process Mining",
    "QPR ProcessAnalyzer",
    "Signavio Process Intelligence",
    "UiPath ProcessGold Process Mining",
    "Celonis Process Mining Platform",
    "Camunda BPM",
    "Adonis BPM",
    "Mavim",
    "LeanIX",
  ],
  "Tech_C/C++":[
    "Smalltalk",
    "Unix Shell Scripting",
    "Uniface",
    "C (Programming Language)",
    "C++ Programming Language",
  ],
  "Tech_Cloud Computing":[
    "Gemstone Gemfire",
    "GitHub",
    "Apigee",
    "Docker (Software)",
    "Kubernetes",
    "Cisco Workload Automation",
    "Google App Engine (GAE)",
    "Google Cloud Functions",
    "Google Apps Scripts",
    "Cloud Technology Architecture",
    "Broadcom Layer 7 API Gateways",
    "WSO2 API Management",
    "Cloud Remediation",
    "Unix to Linux Migration",
    "VMware Tanzu Application Service",
    "Kong Konnect",
    "Kong Gateway",
  ],
  "Tech_Data":[
    "Data Architecture Principles",
    "Master Data Management (MDM)",
    "Actuate",
    "Teradata BI",
    "SAS BI",
    "SAS Base & Macros",
    "QlikView",
    "Informatica Data Quality",
    "Pentaho BI Suite",
    "Pentaho ETL Tool (Kettle)",
    "Neo4j",
    "SAS Analytics",
    "SAS Data Integration",
    "NoSQL",
    "Apache Hadoop",
    "Splunk",
    "Marklogic",
    "Memcached",
    "noSQL Couchbase",
    "Talend Big Data",
    "Micro Focus Vertica",
    "Apache Cassandra",
    "Informatica Product 360 (PIM)",
    "SAS DataFlux ETL Tools",
    "Apache Kafka",
    "IBM Cognos Business Intelligence",
    "Alteryx",
    "IBM Cognos TM1",
    "Data Governance",
    "Data Security",
    "Ab Initio",
    "IBM InfoSphere DataStage",
    "Informatica PowerCenter",
    "New Relic",
    "Redis",
    "R-Studio",
    "Informatica MDM",
    "TIBCO Spotfire",
    "Tableau",
    "Elastic Stack (ELK)",
    "Cloud Data Architecture",
    "Informatica Big Data Edition",
    "SAS Visual Data Mining and Machine Learning",
    "SAS Fraud Management",
    "Data Science",
    "Engineering Support",
    "AI & Data Strategy",
    "Qlik Sense",
    "Apache NiFi",
    "Data Warehouse ETL Testing",
    "MongoDB",
    "Web & Mobile Analytics",
    "Advanced Data Visualization Techniques",
    "MicroStrategy Business Intelligence",
    "IBM Netezza",
    "Python (Programming Language)",
    "Talend ETL",
    "AWS Redshift",
    "Hadoop Administration",
    "Apache Spark",
    "Tableau Prep",
    "RapidMiner",
    "Trifacta Wrangler",
    "Paxata Adaptive Information Platform",
    "AWS Neptune",
    "Informatica Intelligent Cloud Services",
    "Cloud Data Integration",
    "Reltio",
    "Amazon Aurora",
    "Qubole",
    "SiSense",
    "Big Data Analysis Tool and Techniques",
    "SAS Visual Text Analytics",
    "Data Mining",
    "Data Modeling Techniques and Methodologies",
    "Data Transaction Management Patterns & Techniques",
    "Electronic Data Interchange (EDI)",
    "Informatica PowerExchange",
    "PostgreSQL",
    "Test Data Management Implementation",
    "Informatica ILM TDM and TDG",
    "AWS DynamoDB",
    "Amazon EMR",
    "Informatica B2B Data Transformation",
    "Global Information Systems",
    "Data Engineering",
    "Google Compute Engine",
    "AWS BigData",
    "Amazon Kinesis",
    "Apache Storm",
    "Google Cloud Datastore",
    "Google Cloud Storage",
    "Google Cloud SQL",
    "Google BigQuery",
    "GCP Dataflow",
    "Google Cloud Datalab",
    "Google BigTable",
    "Delphix",
    "Google Dataproc",
    "Cloud Data Migration",
    "Looker Studio",
    "Google Cloud Spanner",
    "Data Consulting",
    "Amazon Sagemaker",
    "Snowflake Data Warehouse",
    "Informatica Enterprise Data Catalog",
    "Cloudera Altus",
    "Cloud Change Data Capture",
    "AWS Glue",
    "Amazon Athena",
    "Google Cloud Data Transfer",
    "Google Cloud DataPrep",
    "AWS Relational Database Service",
    "Unifi Data Platform",
    "Alation Data Catalog",
    "Waterline Data",
    "Datameer",
    "Dataiku Data Science Studio (DSS)",
    "Clearstory",
    "Informatica Secure@Source",
    "Informatica Axon",
    "Tamr Unify",
    "AWS Schema Conversion Tool",
    "AWS Database Migration Service (DMS)",
    "Datawatch Monarch",
    "Datawatch Swarm",
    "Google Looker Data Platform",
    "Collibra Data Governance",
    "AWS Document DB",
    "Informatica TDM",
    "Alibaba Cloud DataWorks",
    "Alibaba MaxCompute",
    "Alibaba Cloud Quick BI",
    "Alibaba DataV",
    "Databricks Unified Data Analytics Platform",
    "TIBCO Data Virtualization Platform",
    "Denodo Data Virtualization Platform",
    "Google Cloud Data Services",
    "Cloudera Data Platform",
    "Stibo Product Master Data Management",
    "Alibaba ApsaraDB",
    "Alibaba Data Integration",
    "Qlik Replicate",
    "Qlik Compose",
    "Apache Airflow",
    "Data Wrangling",
    "Cloud Test Data Management",
    "Grafana",
    "PySpark",
    "Data Mesh",
    "SAS Platform",
    "Snowflake Schema",
    "Graph Databases",
    "Informatica Cloud",
    "OneTrust Privacy Management",
    "BigID Data Intelligence Platform",
    "Datarobot",
    "Modern Data Integration",
    "Datadog",
    "AtScale (Platform)",
    "Starburst Enterprise",
    "K2View Data Product Platform",
    "GridGain In-Memory Computing Platform",
    "Collibra Data Quality & Observability",
    "SAS Customer Intelligence 360",
    "Prometheus Event Monitoring System",
    "Palantir Foundry",
    "Plotly",
    "Data Building Tool",
    "Teradata Vantage",
    "Data Observability",
    "DataGaps Test Data Manager",
    "DataGaps DQ Monitor",
    "DataGaps BI Validator",
    "DataGaps ETL Validator",
    "Informatica Cloud Data Governance & Catalog (CDGC)",
    "Informatica Cloud Data Quality (CDQ)",
    "Databricks Unity Catalog",
  ],
  "Tech_DevOps":[
    "DevOps",
    "DevOps Architecture",
  ],
  "Tech_E&I-CS":[
    "JDA i2 Technologies",
    "Warehouse Management Solutions",
    "Kronos",
    "Supply Chain Management (SCM) Applications",
    "IBM Sterling Commerce",
    "JDA Manugistics",
    "BlueYonder Warehouse Management",
    "Order Fulfillment Planning",
    "Supply Chain Supply Planning",
    "Supply Chain Planning Outsourcing Solution Design",
    "Coupa SC Design and Planning (Llamasoft)",
    "Infor Lawson",
    "Extensible Stylesheet Language XSL",
    "BlueYonder Space & Floor Planning",
    "BlueYonder Transportation Management",
    "Kinaxis",
    "Anaplan",
    "BlueYonder Enterprise Supply Planning",
    "BlueYonder Master Planning",
    "BlueYonder Allocation & Replenishment",
    "BlueYonder Demand Planning",
    "BlueYonder Enterprise Planning",
    "BlueYonder Workforce Management",
    "Coupa",
    "Order Management Systems (OMS)",
    "BlueYonder Carrier Collaboration",
    "BlueYonder Price and Promotions Management",
    "BlueYonder Fulfillment",
    "BlueYonder Market Manager",
    "BlueYonder Intelligent Fulfillment",
    "BlueYonder Production Planning",
    "Sourcing & Procurement Solutions",
    "Manhattan Warehouse Solutions Technical",
    "Infor GT Nexus",
    "Logistics Management",
    "BlueYonder Inventory Optimization",
    "BlueYonder Sales & Operations Planning",
    "BlueYonder Order Management",
    "Infor Birst",
    "Tagetik Planning Budgeting and Forecasting",
    "OMP Plus",
    "Infor M3 Process Manufacturing & Distro",
    "Supply Chain Track & Trace",
    "OneStream Extensive Finance SmartCPM",
    "OneStream Specialty Planning Application",
    "OneStream Account Reconciliations",
    "Infor LN for Discrete Manufacturing",
    "Infor OS",
    "O9 Solutions",
    "Supply Chain Networking and Inventory",
    "Korber Warehouse Management Functional",
    "Korber Warehouse Management Technical",
    "E2Open Harmony",
    "E2Open E2Net",
    "E2Open Global Trade Management",
    "E2Open Transportation & Logistics",
    "E2Open Planning Suite",
    "BlueYonder Distributed Order Management",
    "E2Open Supply Management Suite",
    "Composable Technologies",
    "Korber Warehouse Management System (WMS)",
    "Infor Financials & Supply Management",
    "BlueYonder Merchandise Operations",
    "Aera Control Tower",
    "BlueYonder Order Sequencing",
    "Manhattan Transportation",
    "Manhattan Active Order Management Functional",
    "O9 Data Integration",
    "IBM Sterling Warehouse Management System",
    "BlueYonder Cognitive Platform",
    "BlueYonder Order Promisor",
    "One Network Control Tower",
  ],
  "Tech_Finops":[
    "FinOps Operating Model",
  ],
  "Tech_Function Applications":[
    "Verint Systems",
  ],
  "Tech_GCP":[
    "Google Analytics",
    "Google Pub/Sub",
    "Google Kubernetes Engine",
    "Google Cloud Content Delivery Network (CDN)",
    "Google Cloud Interconnect",
    "Google Cloud Domain Name System (DNS)",
    "Google Cloud Machine Learning Services",
    "Google Cloud Load Balancing",
    "Google Drive",
    "Google Calendar",
    "Google Identity and Security",
    "Google Cloud Virtual Private Cloud",
    "Google Cloud Key Management",
    "Google Stackdriver",
    "Google Deployment Manager",
    "Google Workspace",
    "Google Cloud Security Services",
    "Google Cloud Dataproc",
    "Google Cloud Development Services",
    "Google Cloud Network Services",
    "Google Cloud DevOps Services",
    "Google Cloud Data Catalog",
    "Google Cloud Data Fusion",
    "Google Cloud Compute Services",
    "Google Cloud Container Services",
    "Google Hybrid Architecture",
    "Google Cloud Gemini",
    "Google Cloud Model Garden on Vertex AI",
    "Google Ads Implementation",
    "Google App Engine Python",
    "Google App Engine Java",
    "Google Maps",
    "Google Cloud Firebase",
    "Google Material Design",
    "Google CES Conversational Agent",
    "Google Cloud Search",
    "SAP Cloud Migration on GCP",
    "Google Cloud Firestore",
    "Google Cloud IoT",
    "Google BigQuery Migration Service",
    "Google Cloud Native Applications",
    "Google Kubernetes Development",
    "Google Event Driven Architecture",
    "Google Integration Architecture",
    "Google Cloud Operations",
    "Google Cloud Application Migration",
    "Google AutoML",
    "Google Cloud Natural Language API",
    "Google Cloud Speech API",
    "Google Cloud Video Intelligence API",
    "Google Cloud Vertex AI Pipeline Development",
    "Google Cloud Vertex AI Infrastructure",
    "Google Cloud Vision API",
    "Google Advanced Agent Modeling (AAM)",
    "Google Cloud Text to Speech",
    "Google Cloud Speech to Text",
    "Google CES Agent Assist",
    "Google CES Insights",
    "Google CES Telephony Integration",
    "Google Cloud Contact Center AI Platform",
    "Google Cortex",
    "Google Cloud BigLake",
    "Google Analytics GA4 Visualization",
    "Google Cloud Data Loss Prevention API",
    "Google Cloud Run",
    "Google Cloud Storage Transfer Service",
    "Google Bard",
    "Google Generative AI Studio",
    "Google PaLM",
    "Google What-If Tool",
    "Google Vertex Explainable AI",
    "Google Translate",
    "Google Cloud Platform",
    "Google Ads",
    "Google Cloud Platform (GCP) for Machine Learning",
    "Google Cloud Vertex AI Vision",
    "Google Cloud Generative AI Language Models",
    "Google Cloud Vertex AI Model Registry",
    "Google Cloud Supervised Model Tuning",
    "Google Cloud Duet AI",
    "Google Cloud Document AI",
    "Google Cloud Translation AI",
    "Google Cloud Vertex AI Search",
    "Google Cloud Embeddings API",
    "Google Cloud Codey",
    "Google Cloud Chirp",
    "Google Cloud Imagen",
    "Google Cloud Gemma",
  ],
  "Tech_Hostcentric Platform":[
    "Assembler (Programming Language)",
    "IBM CICS (Customer Information Control System)",
    "IBM Db2",
    "Job Control Language (JCL)",
    "Natural",
    "PL/I (Programming Language)",
    "Restructured Extended Executor (REXX)",
    "HPE NonStop",
    "Virtual Storage Access Method (VSAM)",
    "AS/400 COBOL 400 (Programming Language)",
    "Broadcom CA Gen",
    "Adabas (Software)",
    "Mainframe Testing",
    "Cobol Mainframe",
    "Broadcom CA ADS",
    "IBM iSeries",
    "Mainframe DevOps",
    "IBM AS/400 RPG III",
    "IBM DB2/400",
    "IBM Information Management System (IMS) Database",
    "IBM IMS Transaction Manager",
    "IBM System i (AS/400) RPG IV",
    "IBM z/OS",
    "IBM z/OS Unix System Services",
    "IBM Rational Developer for System z",
  ],
  "Tech_Hybrid Cloud Solution":[
    "12 Factor Applications",
    "Hybrid Cloud Security",
    "Automation Anywhere",
    "VMware TKG Tanzu Kubernetes Grid",
    "VMware Cloud on AWS",
    "VMware Cloud Foundation",
    "Site Reliability Engineering",
    "HPE Greenlake Solution",
    "Dell Apex Solution",
    "Google Cloud VMware Engine (GCVE)",
    "Hybrid Cloud Solutions",
  ],
  "Tech_IBM_Red Hat":[
    "WildFly",
    "Red Hat OpenShift",
    "IBM Business Process Manager (BPM)",
    "JBoss Fuse",
    "Red Hat Fuse Administration",
    "IBM API Connect",
    "IBM Integration Bus",
    "Red Hat 3scale API Management",
    "IBM WebSphere DataPower",
    "IBM WebSphere MQ",
    "IBM Sterling B2B Integrator",
    "IBM Operational Decision Manager",
    "IBM Cloud",
    "IBM Watson Cognitive Services",
    "IBM App Connect",
    "IBM Cloud Pak for Data",
    "IBM Cloud Pak for Integration",
    "IBM Cloud Pak for Automation",
    "IBM Cloud Pak for Multicloud Management",
    "Red Hat Decision Manager",
    "Red Hat Process Automation Manager",
    "Mainframe Modernization",
    "Red Hat JBOSS Enterprise Application Platform (EAP)",
    "Red Hat AMQ",
    "IBM watsonx.data",
    "IBM watsonx.ai",
    "IBM watsonx.governance",
    "IBM Turbonomic",
    "Red Hat Advanced Cluster Management",
    "OpenShift Virtualization",
    "IBM Instana",
    "IBM Watsonx",
  ],
  "Tech_Industry X.0":[
    "Session Initiation Protocol (SIP)",
    "Email Security",
    "Oracle Agile PLM",
    "Dassault Systemes 3DEXPERIENCE Platform APRISO",
    "Dassault Systemes ENOVIA V5",
    "PTC Windchill",
    "Siemens Teamcenter",
    "Infor WFM Workbrain",
    "Long-Term Evolution (LTE)",
    "ClickSoftware",
    "Radio-Frequency Identification (RFID)",
    "Lean Manufacturing",
    "Manufacturing Operations",
    "Quality Management",
    "Six Sigma",
    "ISO Standard",
    "Dassault Systemes 3DEXPERIENCE Platform DELMIA Quintiq",
    "IBM Maximo",
    "Pro*C Programming Language",
    "Technical Writing",
    "3D Designing",
    "IFS Field Service Management FSM",
    "Dassault Systemes 3DEXPERIENCE CATIA",
    "Capability Maturity Model Integration (CMMI) Assessments",
    "Competitor Analysis",
    "Downstream Hydrocarbon Supply Chain",
    "Downstream Manufacturing",
    "Master Data Maintenance",
    "General Electric (GE) Application Performance Management (APM)",
    "Planisware",
    "Rockwell",
    "Statistical Analysis",
    "Moodle",
    "Adobe Photoshop",
    "Apache HTTP Server",
    "MATLAB",
    "Process Design Mapping and Analysis",
    "Product Lifecycle Management (PLM)",
    "Shell Scripting",
    "Cluster Analysis",
    "Risk Analysis & Modeling",
    "Adobe Illustrator",
    "AWS S3 (Simple Storage Service)",
    "Change Management",
    "Automotive Digital Cockpit Solutions",
    "RTOS Architecture",
    "Core Board Support Package Drivers",
    "Cellular Radio Protocol Stack",
    "Physical Site Security",
    "Django",
    "Sustainable Product Lifecycle Management",
    "Technical Drawings",
    "Financial Stress Testing",
    "Minitab",
    "Oracle Primavera P6",
    "Internet of Things (IoT)",
    "Allegro ERTM",
    "Aveva OSIsoft PI",
    "Triple Point XL",
    "Bentley Architecture & Design Solutions",
    "Dassault Systemes 3DEXPERIENCE Platform ENOVIA",
    "Linear Algebra",
    "Infor",
    "Data Analytics",
    "Process Engineering",
    "Data Visualization",
    "Mendix (Platform)",
    "Accenture Digital Video Solution IPTV",
    "Assembly Testing",
    "Autodesk AutoCAD",
    "Dassault Systemes SolidWorks",
    "Embedded Software",
    "Android SDK",
    "Business Intelligence (BI) Reporting Tools",
    "Configuration & Release Management",
    "Hexagon Intergraph SmartPlant",
    "Connected Vehicles",
    "Connected Asset Management",
    "Asset Life Cycle Management",
    "Siemens Simatic",
    "SAP Asset Performance Management (APM)",
    "R Programming",
    "PTC FlexPLM",
    "Parametric Modeling",
    "FEA Mechanical Static",
    "FEA Mechanical Dynamic",
    "Deep Learning",
    "SAP Asset Management",
    "Aviation Service Providers",
    "Honeywell Asset Sentinel",
    "Aspen Process Industry Modeling System (PIMS)",
    "Crowd Testing Services Management",
    "Oracle Utilities Mobile Workforce Management (MWM)",
    "Hexagon Enterprise Asset Management",
    "Network Testing",
    "Semiconductor Manufacturing & Test",
    "ACPS - EPDS",
    "FEA Simulation",
    "Information Security Management System (ISMS)",
    "Data Validation and Cleansing",
    "Database Management",
    "Incident Management",
    "Process Control",
    "Operational Support Systems (OSS)",
    "Telecom Audit",
    "Wireless Network Strategy & Design",
    "Manufacturing Operations Management (MOM)",
    "Concept Prototyping",
    "Client Invoicing",
    "Security Risk Assessment",
    "Solid Edge",
    "Autodesk Inventor",
    "ANSYS Software",
    "IoT Device Management",
    "Manufacturing Design & Engineering Solutions",
    "Industry X Security",
    "Human Machine Interaction",
    "Industry X IOT Applications",
    "Embedded Firmware",
    "Advanced Embedded System Engineering",
    "Embedded Multimedia",
    "Manufacturing Engineering L2 Automation",
    "Internet of Things (IoT) Platforms",
    "AVEVA PDMS",
    "Hexagon EcoSys",
    "Network Strategy & Optimization",
    "ACPS Product Lifecycle Management",
    "Manufacturing Engineering MES",
    "Embedded Applications Testing",
    "IBM TRIRIGA",
    "Gemalto Internet of Things Solutions",
    "C# Programming Language",
    "Java",
    "Siemens NX",
    "Creo Parametric",
    "Sitecore MVC",
    "Data Protection Advisory Services",
    "Threat Intelligence Operations",
    "ng-bootstrap",
    "Digital Field Worker Mobility",
    "Robotics Aldebran Platform",
    "Smart Grid Monitoring",
    "Unity3D",
    "Industrial IoT Device Testing",
    "IoT Application Security Testing",
    "Industrial IoT Platform Testing",
    "Siemens Manufacturing Execution System (MES)",
    "AVEVA InTouch HMI",
    "Rockwell Automation Software",
    "Siemens Teamcenter Unified Architecture",
    "Siemens Interspec",
    "BETA CAE ANSA",
    "Palo Alto ICS/SCADA Security",
    "Modscan32",
    "Security Incident Containment",
    "PLC SCAN",
    "Transit Fare Payment Solutions",
    "Embedded Product Maintenance & Operation",
    "Embedded C",
    "Embedded C++",
    "Embedded Hardware Abstraction Layer",
    "Embedded Device Management",
    "Embedded Windows App Development",
    "Embedded Android App Development",
    "Embedded Linux App Development",
    "Industry X Robotics",
    "Embedded Product Verification & Validation",
    "Eclipse KURA",
    "Robot Operating System (ROS)",
    "Set-Top Box (STB) Testing",
    "Embedded Device Security",
    "AWS Internet of Things (IoT)",
    "General Electric (GE) Predix Platform",
    "Siemens Mindsphere",
    "PTC ThingWorx",
    "Thingworx",
    "Sketch (Software)",
    "Balsamiq",
    "Invision",
    "Justinmind Prototyper",
    "Mockplus",
    "SmartDraw",
    "Tobii Pro Solutions",
    "Eye Tracking EyeWorks",
    "Foundry Modo",
    "ARToolKit",
    "PTC Vuforia Engine",
    "Kudan AR SDK",
    "Wikitude AR SDK",
    "Dassault Systemes 3DEXPERIENCE",
    "Dassault Systemes 3DEXPERIENCE Platform DELMIA",
    "General Electric (GE) Plant Applications",
    "Siemens Tecnomatix Plant Simulation",
    "MSC Nastran",
    "Dassault Systemes 3DEXPERIENCE Platform SIMULIA",
    "Altair HyperWorks",
    "MSC Patran",
    "Fortinet Solutions",
    "Rapid7 Metasploit",
    "Attify Solutions",
    "Automotive ECU Software",
    "Multimedia Codecs",
    "Big Data Administration",
    "SAP Product Lifecycle Management for Insurance (FS-PRO)",
    "PowerFactory",
    "Autodesk BIM 360 Field",
    "Data Protection & Privacy Impact Assessment",
    "ESRI ArcGIS",
    "Scrum",
    "PTC Kepware",
    "Anaconda Platform",
    "Business Insights",
    "Dassault Systemes 3DEXPERIENCE Platform EXALEAD",
    "Dassault Systemes 3DEXPERIENCE Platform 3DVIA",
    "Dassault Systemes 3DEXPERIENCE Platform BIOVIA",
    "Dassault Systemes 3DEXPERIENCE Platform NETVIBES",
    "Dassault Systemes 3DEXPERIENCE Platform 3DEXCITE",
    "Product Requirement Definition",
    "Project Program & Portfolio Governance",
    "Data Structures and Algorithms",
    "Mechanical Design Engineering",
    "PLM Bills of Materials (BOM)",
    "PLC Software Development",
    "Dassault Systemes 3DEXPERIENCE ENOVIA Customization",
    "Dassault Systemes 3DEXPERIENCE DELMIA Customization",
    "Dassault Systemes 3DEXPERIENCE APRISO Customization",
    "Additive Manufacturing",
    "5G NetWork Data Analytics Function (NWDAF)",
    "Automotive Supply Chain",
    "Enterprise Asset Management Applications",
    "Operational Audit & Compliance",
    "Lean Portfolio Management",
    "Werum Manufacturing Execution Solution PAS-X",
    "Financial Benchmarking",
    "Internal Audit Quality Assurance",
    "Accenture Manage mySales (MMS)",
    "Edge Computing",
    "Software AG Cumulocity IoT",
    "Aras Innovator Customization",
    "Accenture IX Bedrock Test Automation",
    "Platform Engineering",
    "Aspen HYSYS",
    "Image Editing",
    "General Electric (GE) Proficy Manufacturing Execution System",
    "PSI Metals Manufacturing Execution System",
    "Tulip Manufacturing Execution System",
    "Operating Model Implementation",
    "Aveva Predictive Analytics (Prism)",
    "AspenOne APM",
    "Aveva Mobile Operator",
    "Coreworx",
    "Hexgon IsoGEN",
    "Aspen Ops Reconciliation & Accounting AORA",
    "Aspen InfoPlus.21",
    "Hexagon j5 Shift Operations Management",
    "Aveva Spiral",
    "CorityOne",
    "Cognite Data Fusion",
    "Adiabatic Annealing Computation",
    "Bentley AssetWise",
    "Capital Project Information Systems",
    "Environment Health and Safety",
    "People Safety & Health",
    "Capital Project Management Capability Development",
    "Statistical Process Control (SPC)",
    "Capital Project Controls & Analytics",
    "Capital Project Sourcing and Procurement",
    "Engineering Data and Information Management",
    "Agricultural Equipment",
    "Should Cost Model",
    "Value Engineering (VE)",
    "Hardware Debugging",
    "Pytest",
    "Battery Storage Solutions",
    "Aircraft Manufacturing",
    "Aircraft Structures",
    "Aircraft Systems",
    "Airworthiness",
    "ANSYS LS-DYNA",
    "Automotive Transmission Systems",
    "Aviation Communications ATA Standards",
    "Aviation Electrical Panels ATA Standards",
    "Aviation Galley/Lavatories ATA Standards",
    "C3 Charts",
    "Celery (software)",
    "Composites Design",
    "Computational Fluid Dynamics (CFD)",
    "Fatigue & Damage Tolerance F&DT",
    "Forsk Atoll Planning Tool",
    "Geometric Dimensioning And Tolerancing (GD&T)",
    "Gypsy (software)",
    "Qualcomm eXtensible Diagnostic Monitor QXDM",
    "Radio Network Integration",
    "Radio Network Managed Services",
    "Electric/Electronic Software Architecture",
    "AUTOSAR",
    "Autonomous Driving Assistance Systems",
    "Automotive Functional Safety & Security",
    "PTC Codebeamer",
    "Asset Performance Management (APM)",
    "2D Designing",
    "Adobe Acrobat",
    "Graphical User Interface (GUI)",
    "Siemens Polarion ALM",
    "Dassault Systemes 3DEXPERIENCE Platform DELMIA Ortems",
    "Dassault Systemes 3DEXPERIENCE Platform GEOVIA",
    "Jupyter Notebook",
    "Notepad++",
    "pgAdmin",
    "PyCharm",
    "TortoiseSVN",
    "Accuver XCAL",
    "Radio Network Optimization",
    "Radio Network Planning",
    "TEMS Investigation",
    "Taiga.Io",
    "Aerodynamics",
    "Aerospace Quality Management Standards",
    "Airbus Authoring & Configuration Guidelines",
    "Airbus Delivery Guidelines",
    "Airbus Illustration Guidelines",
    "Vehicle Crash Analysis",
    "Aircraft Design",
    "Aircraft Maintenance",
    "Vehicle Routing",
    "STAR-CCM+",
    "Aircraft Structural Analysis",
    "Technia Q-Checker",
    "Vehicle Modeling",
    "Vehicle Packaging",
    "Wiring Harnesses",
    "TEMS Discovery",
    "Quality-One Advanced Product Quality Planning Tool",
    "Nmap Security Scanner",
    "SIPVicious OSS",
    "Vega Vulnerability Scanner",
    "SIPp Testing Tool",
    "ProjectCompanion",
    "Accenture Project Management Tool",
    "Accenture TecDraw",
    "Accenture Tweet",
    "Aircraft Maintenance Manual Authoring Guidelines",
    "Aircraft Schematics Manual Authoring Guidelines",
    "Aircraft Structure Repair Manual Authoring Guidelines",
    "Aircraft Wiring List Manual Authoring Guidelines",
    "Aircraft Wiring Manual Authoring Guidelines",
    "Aviation ATA 100 Standards",
    "Aviation ATA iSpec 2200 Standards",
    "Aviation ATA S1000D Standards",
    "Model-Based Definition (MBD)",
    "nCode DesignLife",
    "Non-Conformance Reporting (NCR)",
    "NVH Testing",
    "Vehicle Integration",
    "Airbus Configuration Tools",
    "Aircraft Illustrated Parts Catalogue Authoring Guidelines",
    "Electric Vehicle Infrastructure",
    "Automotive Software Defined Vehicles",
    "Automotive Mobility Services & Connected Vehicles",
    "Automotive Parts",
    "Automotive Engineering",
    "Vehicle Architecture",
    "OTA Management",
    "BakerHughesC3.ai",
    "Robotics Design & Simulation",
    "Advanced Distribution Management System (ADMS) Technical Architecture",
    "Parsec TrakSYS",
    "AVEVA Manufacturing Execution System",
    "Critical Manufacturing MES",
    "Emerson Manufacturing Execution Solution Syncade",
    "Rockwell Manufacturing Execution System FactoryTalk",
    "Rockwell Automation FactoryTalk PharmaSuite",
    "Model-Based Systems Engineering (MBSE)",
    "Camos CPQ",
    "Tacton CPQ",
    "Siemens Rulestream",
    "ConfigIT",
    "Aircraft Interior Design",
    "Automotive Technical Publication",
    "Nvidia Omniverse",
    "NVIDIA AI Foundations",
    "3D Simulations",
    "Discrete Event Simulation",
    "Siemens Teamcenter X",
    "Siemens Capital",
    "Siemens Opcenter X",
    "Siemens Industrial Edge",
    "Siemens Insights Hub",
    "Siemens Tecnomatix",
    "Siemens Simcenter",
    "Siemens Solid Edge",
    "Siemens Opcenter Execution Discrete",
    "IFS Mobile Workforce Management (MWM) ",
  ],
  "Tech_IPS_Innovation":[
    "Technological Innovation",
    "Design Innovation",
    "Innovation Strategy & Management",
    "Industry Insight",
    "IBM Quantum",
    "Services Innovation",
    "Ecosystem Management",
  ],
  "Tech_IT Strat & Transformation":[
    "Business Technology",
    "Application Rationalization",
    "Enterprise Architecture Framework",
  ],
  "Tech_Java Technology Platform":[
    "Java Server Faces (JSF)",
    "JavaServer Pages (JSP)",
    "Java Servlets",
    "Spring MVC (Model View Controller)",
    "Apache Tomcat Application Deployment",
    "Oracle WebLogic Application Server",
    "IBM WebSphere Application Server Application Deployment",
    "Java Deployment Technologies",
    "Java Standard Edition",
    "JavaScript",
    "Ruby on Rails",
    "Spring Application Framework",
    "jQuery",
    "Spring Boot",
    "Asynchronous JavaScript and XML (AJAX)",
    "Blaze Advisor Rules Engine",
    "Hibernate ORM",
    "WebSphere ILOG JRules",
    "Java Enterprise Edition",
    "JavaFX",
    "Jakarta Enterprise Beans",
    "Node.js",
    "React.js",
    "Hyper Text Markup Language (HTML)",
    "Spring Cloud Data Flow Platform",
    "Angular",
    "JasperReports",
    "Java Full Stack Development",
    "Scala",
    "Accenture Connected Technology Solution (ACTS)",
  ],
  "Tech_Metaverse":[
    "Market Mix Modeling",
    "Sales Talent Management",
    "Training Environment Strategy",
    "Time Series Modeling",
    "Blender 3D Modeling",
    "Maya Animation & Modeling",
    "Distributed Transaction Patterns & Techniques",
    "Inside Sales",
    "3D Scanning",
    "Virtual Reality",
    "Augmented Reality (AR)",
    "Decentralized Systems",
    "Ripple XRP Ledger",
    "R3 Corda",
    "Hyperledger Fabric",
    "Ethereum-Based Quorum",
    "Upskill Skylight",
    "Spatial Audio",
    "Microsoft HoloLens",
    "Unreal Engine",
    "Assisted Reality",
    "Mixed Reality",
    "Virtual Reality Content Creation",
    "R Language and Environment",
    "Maxon Cinema 4D",
    "Autodesk 3ds Max",
    "Motion Graphics Design",
    "Audio Design",
    "Unity Programming",
    "Public Key Infrastructure",
    "Ibm Blockchain Platform",
    "Blockchain Technology",
    "Blockchain Business Solutioning",
    "Multichain",
    "Zero-Knowledge Proof",
    "Blockchain Platform Administration",
    "PTC Vuforia Studio",
    "Amazon Comprehend",
    "Blockchain Platform Architecture and Design",
    "ARKit",
    "Unity 3D - Entity Component System (ECS)",
    "Unity 3D - User Interface (UI)",
    "CAD Model Decimation",
    "Light & Reflection Probes",
    "BlendShape",
    "ARCore",
    "Rust (Programming Language)",
    "Sales Operations & Execution Analytics",
    "Trusted Supply Chain",
    "Illustration Design",
    "Blockchain Testing",
    "Tangible Interaction Design",
    "Metaverse ROI Analysis",
    "Metaverse Business Case Development",
    "Playtesting",
    "3D Narrative Design",
    "Metaverse Concept & Design",
    "Metaverse Channel Environment",
    "Metaverse Channel Capabilities",
    "Metaverse Interaction Handling",
    "Metaverse Performance Management",
    "Metaverse Learning Content Development",
    "Metaverse Learning Implementation",
    "Metaverse Quality Management",
    "Metaverse Customer Experience Transformation",
    "Metaverse Customer Sentiment Analysis",
    "Metaverse Reporting Analytics",
    "Audio Programming",
    "Music Composition",
    "Audio Engineering",
    "Audio Strategy",
    "Audio Prototyping",
    "Metaverse B2B Seller Onboarding",
    "Metaverse B2B Partner Onboarding",
    "Metaverse B2B Seller Ecosystem",
    "Metaverse B2B Partner Ecosystem",
    "Metaverse Sales Writing",
    "Metaverse Deal Shaping",
    "Metaverse Sales Training",
    "DIDWeb Messaging",
    "AWS Quantum Ledger Database (QLDB)",
    "AWS Managed Blockchain",
    "Microsoft Mesh Platform",
    "Microsoft AltspaceVR Platform",
    "Game Design",
    "Accenture Immersive Collaboration Platform",
    "Spark AR Studio",
    "3D Environment Creation",
    "Motive.IO Platform",
    "Strivr Platform",
    "Talespin Platform",
    "ShapesXR Platform",
    "LightWave 3D Platform",
    "Solidity",
    "Decentralized Identifier DID Registry",
    "Revocation Registry",
    "Self-Sovereign Identity (SSI)",
    "Trust Over IP TOIP",
    "Hyperledger Indy",
    "Indicio Technologies",
    "Hyperledger Ursa",
    "DIDComm Messaging",
    "OIDC Self-Issued OpenID Provider",
    "Oculus Development",
    "Web Based Augmented Reality WebAR",
    "Nvidia CloudXR",
    "Varjo XR Platform",
    "Extended Reality XR Sensors",
    "Advanced Locomotion Systems",
    "OpenVR Development",
    "Hyperledger Aries",
    "Microsoft Mixed Reality Toolkit MRTK",
    "Microsoft Azure Remote Rendering",
    "Immerse.io Platform",
    "Cognitive3D",
    "PlayCanvas",
    "Digital Asset Modeling Language (DAML)",
    "Hyperledger Besu",
    "VMWare Blockchain",
    "Canton Digital Asset",
    "Parity Substrate",
    "Diem Blockchain",
    "Oracle Blockchain Tables",
    "Hyperledger Bevel",
    "Hyperledger Cactus",
    "Hyperledger Caliper",
    "Hyperledger Firefly",
    "Interledger Protocol",
    "Metamask Software",
    "Fireblocks Software",
    "Haptics Technology",
    "Babylon.js",
    "WebGL",
    "Microsoft Entra Verified ID",
    "Accenture Unique DID Service Platform UDISP",
    "Identity Foundation ION",
    "Avast Digital Trust Services Verity Flow",
    "Avast Digital Trust Services Connect.me",
    "Handtracking Technology",
    "Distributed Marketplaces Development",
    "Wallet & Credential Interactions WACI",
    "CorDapp Development",
    "Chaincode Development",
    "Biomimicry",
    "Avast Digital Trust Services Verity",
    "Verifiable Credentials",
    "Motion Capture Systems",
    "Simulation Rigs",
    "3D Data Analysis",
    "Microsoft Guides",
    "Spatial UI",
    "Pixologic ZBrush",
    "Retopology",
    "3D Modeling",
    "Extended Reality XR Device Management",
    "Character Concept Design",
    "Real Time Character Modeling",
    "Accenture EliXR",
    "3D UX Interaction Visual Design",
    "3D UX Interaction Prototyping",
    "3D UX Wireframing",
    "3D UI Design",
    "3D UI Prototyping",
    "3D UI Asset Creation",
    "Real-Time 3D Content Pipeline",
    "Physical Based Rendering PBR Texturing",
    "Volumetric Capture",
    "3D Game Engine",
    "Concept Art",
    "Central Bank Digital Currency (CBDC)",
    "Metaverse Native Cryptocurrency",
    "Metaverse Commercial Platform Payment Tokens",
    "Cryptocurrency",
    "Token Standards",
    "Metaverse Interoperability & Standards",
    "Metaverse Commercial Platform Custody",
    "Card Payments for Digital Assets",
    "Card Payments for Commercial Platform Tokens",
    "Metaverse Native Cryptocurrency Payments",
    "Stablecoin Payments",
    "Cryptocurrency Customer Rewards",
    "Metaverse Customer Rewards",
    "Decentralized Token Marketplaces",
    "Commercially Owned Token Marketplaces",
    "Decentralized Digital Asset Exchange",
    "Commercially Owned Digital Asset Exchange",
    "Decentralized Market Infrastructure",
    "Centralized Market Infrastructure",
    "Metaverse Commercial Platform Token Exchange",
    "Stablecoin Regulations",
    "Cryptocurrency Regulations",
    "Digital Asset Custody Regulations",
    "Digital Asset Market Regulations",
    "Metaverse Regulations",
    "Multiparty Traceability Architecture",
    "Multiparty Traceability Platforms",
    "Traceability Standards & Regulations",
    "Immersive Supply Chain Architecture",
    "Virtualized Supply Chain Operations",
    "Supply Chain Consortiums",
    "Metaverse Supply Chain Control Towers",
    "Digitally Augmented Supply Chain Operations",
    "Metaverse Customer Experience Enablement",
    "Stablecoins",
    "Non-Fungible Tokens (NFT)",
    "Metaverse Commercial Platform Objects",
    "Non-Custodial Wallets",
    "Custodial Wallets",
    "Tokenization",
    "Metaverse Commercial Platform Distribution",
    "Extended Reality XR Job-Skill Simulations",
    "Extended Reality XR Soft-Skill Simulations",
    "Extended Reality XR Collaboration Experience",
    "Extended Reality XR Co-Working Strategy",
    "Extended Reality XR Facilitation",
    "Synthetic Intelligence Management",
    "Cognitive Agents",
    "Metaverse Platforms Architecture",
    "Extended Reality XR Head Mounted Displays",
    "Extended Reality XR Job Aids",
    "Metaverse Growth Strategy",
    "Metaverse Market Analysis",
    "Metaverse Value Proposition",
    "Metaverse User Experience Research",
    "Metaverse Design Experience Research",
    "Metaverse Product Innovation",
    "Metaverse Experimentation",
  ],
  "Tech_Microsoft Business Apps":[
    "Microsoft Dynamics AX Technical",
    "Microsoft Dynamics CRM Technical",
    "Microsoft Dynamics CRM Functional",
    "Microsoft Dynamics NAV",
    "Microsoft Dynamics AX Financial Core Functionality",
    "Microsoft Dynamics AX Operations Functional",
    "Microsoft Dynamics CRM Architecture and Integration",
    "Microsoft Dynamics 365 ERP Technical",
    "Microsoft Dynamics 365 Customer Relationship Management (CRM) Functional",
    "Microsoft Dynamics 365 Finance Functional",
    "Microsoft Dynamics 365 Operations Functional",
    "Microsoft Dynamics 365 Supply Chain Management",
    "Microsoft Dynamics 365 Performance Testing",
    "Microsoft Dynamics 365 Project Operations",
    "Microsoft Dynamics 365 for Supply Chain Management Lean Manufacturing",
    "Microsoft Dynamics 365 Commerce Technical",
    "Microsoft Dynamics 365 Commerce Functional",
    "Icertis Contract Intelligence ICI Platform Functional",
    "Icertis Contract Intelligence ICI Platform Technical",
    "Microsoft Dynamics 365 Business Central Technical",
    "Microsoft Dynamics Business Central Functional",
    "Microsoft Dynamics 365 for Supply Chain Management Process Manufacturing",
    "Microsoft Dynamics 365 Customer Engagement (CE) Core Development",
    "Microsoft Dynamics 365 Technical Architecture",
    "Microsoft Dynamics Digital Contact Center Platform",
    "Microsoft Dynamics 365 Security",
    "Microsoft Dynamics 365 Copilot",
  ],
  "Tech_Microsoft Platform":[
    "Sitecore Commerce",
    "Microsoft Visual Basic",
    "Microsoft ASP.NET",
    "Microsoft SQL Server Analysis Services (SSAS)",
    "Microsoft Windows Communication Foundation (WCF)",
    "Visual Basic for Applications (VBA) Programming Language",
    "Visual C++ Programming Language",
    "Microsoft InfoPath",
    "K2 Blackpearl Business Product Management (BPM)",
    "Microsoft Forms",
    "Microsoft Windows Presentation Foundation (WPF)",
    "Microsoft SharePoint Server Development",
    "Microsoft Azure PaaS",
    "Microsoft BizTalk Server",
    "Microsoft Coded UI Test (CUIT)",
    "Microsoft Test Manager (MTM)",
    "Microsoft Load Test",
    "Windows Scripting",
    "Microsoft Copilot Studio",
    "Microsoft 365 Copilot Configuration and Roll Out",
    "Microsoft 365 Copilot Custom Solutions",
    "Microsoft SDET",
    "Sitecore",
    "Microsoft Business Intelligence (BI) Testing",
    "Microsoft SharePoint Testing",
    "Microsoft Xamarin",
    "ASP.NET MVC",
    "Microsoft Front End Development (FED)",
    "Metalogix",
    "Microsoft Azure Modern Data Platform",
    "Microsoft SQL Server",
    "Microsoft SQL Server Integration Services (SSIS)",
    "Microsoft SQL Server Reporting Services",
    "Microsoft Identity Manager (MIM)",
    "Microsoft Azure Internet of Things (IOT)",
    "Microsoft Universal Windows Platform (UWP)",
    "Microsoft User Interface Design",
    "Microsoft Front End Development (FED) Angular",
    "Microsoft SharePoint Server2013 Development",
    "Microsoft 365 SharePoint Online Development",
    ".NET Architecture",
    "Kentico (Software)",
    "Microsoft Avanade Agile Framework (AAF)",
    "Microsoft Office Project Server",
    "Microsoft BOT Framework",
    "Microsoft Azure DevOps",
    "Microsoft Functional Testing",
    "Microsoft FED ReactJS",
    "Microsoft Front End Testing",
    "Microsoft Robotic Process Automation Advanced",
    "EPiServer",
    "Microsoft Active Directory",
    "Lotus Notes to Microsoft SharePoint Application Migration",
    "Microsoft Robotic Process Automation",
    "Akumina",
    "Microsoft Azure Active Directory",
    "Microsoft Power Apps",
    "Microsoft Teams Development",
    "Avanade Scrum Coaching & Advisory",
    "Avanade Scrum Project Management",
    "Microsoft Power Business Intelligence (BI)",
    "Microsoft Identity and Access Management Operations",
    "Microsoft Azure Machine Learning",
    "Microsoft Azure Security",
    "Microsoft Defender",
    "QuickBase",
    "Microsoft Application Architecture",
    ".Net Full Stack Development",
    "Sitecore Content Hub",
    "Microsoft Digital Marketing Services",
    "Microsoft Adobe Experience Cloud Platform",
    "Microsoft Azure Sentinel",
    "Microsoft 365 Security & Compliance",
    "Microsoft Azure Data Services",
    "Microsoft Azure Analytics Services",
    "Microsoft Power Pages",
    "Microsoft Creative Design",
    "Microsoft Azure Communication Services",
    "Microsoft Azure Containerization Development",
    "Microsoft Azure Integration Services",
    "Sight Machine Data on Azure",
    "Microsoft Purview",
    "Microsoft Front End Development (FED) NextJS",
    "Microsoft Azure OpenAI Service",
    "Microsoft Application Security Testing",
    "Microsoft XR Design",
    "Microsoft XR Development",
    "Microsoft Viva Development",
    "GitHub Actions",
    "Microsoft Cloud Enterprise Architecture",
    "Microsoft Cloud Application Architecture",
    "Microsoft Fabric",
    "Microsoft Front End Development React Native (FED React Native)",
    "Microsoft Azure Databricks",
    "Microsoft Azure AI foundry",
    "Microsoft Agentic AI Architecture",
  ],
  "Tech_myConcerto":[
    "Accenture MyConcerto",
    "Accenture myConcerto for SFDC",
    "Accenture myConcerto for ORACLE",
    "Accenture myConcerto for SAP",
    "Accenture myConcerto for WORKDAY",
  ],
  "Tech_Open Source":[
    "Apache OpenOffice",
    "Joomla Content Management System (CMS)",
    "JBoss Enterprise Service Bus (ESB)",
    "JBoss jBPM",
    "Perl Scripts",
    "PHP (Programming Language)",
    "Linux",
    "MySQL",
    "JBoss Fuse Service Works",
  ],
  "Tech_Operations Architectures":[
    "Enterprise Systems Monitoring Tools",
    "System Monitoring Tools & Techniques",
    "SRE Observability",
  ],
  "Tech_Oracle":[
    "Oracle Customer Data Management (CDM)",
    "Oracle Data Miner",
    "Oracle Data Warehouse Solution Architecture",
    "Oracle Business Intelligence Discoverer",
    "Oracle CRM Service",
    "Oracle Forms",
    "Oracle Procedural Language Extensions to SQL (PLSQL)",
    "Oracle Order Fulfillment",
    "Oracle Procurement",
    "Oracle SCM Advanced Procurement",
    "Oracle SCM Logistics",
    "Oracle SCM Manufacturing",
    "Oracle Order Management",
    "Oracle SCM Supply Chain Execution",
    "Oracle SCM Supply Chain Planning",
    "Oracle BI Technical Architecture",
    "Oracle Applications DBA",
    "Oracle Applications Development",
    "Oracle Business Intelligence Applications (OBIA)",
    "Oracle BI Application (OBIA) Contact Center Telephony Analytics",
    "Oracle Business Intelligence Enterprise Edition (OBIEE) Plus",
    "Oracle Applications Reports",
    "Oracle Application Express (APEX)",
    "Oracle Master Data Management MDM Suite",
    "Oracle WebCenter Sites",
    "Oracle EBS Project Management",
    "Oracle Financials",
    "Oracle Hyperion Financial Management (HFM)",
    "Oracle Hyperion Interactive Reporting",
    "Oracle Hyperion Planning",
    "Oracle Hyperion System 9 Business Intelligence",
    "Oracle Warehouse Management",
    "Oracle Supply Chain Management (SCM)",
    "Oracle EBS Tax",
    "Oracle Application Framework (OAF)",
    "Oracle Hyperion Analytic Applications",
    "Oracle EBS Enterprise Asset Management",
    "Oracle Mobile Supply Chain Applications (MSCA)",
    "Oracle iProcurement",
    "Oracle Inventory Management",
    "Oracle Cloud Product Configurator",
    "Oracle Product Data Hub (PDH)",
    "Oracle EBS Procurement Sourcing",
    "Oracle Procurement Sourcing",
    "Oracle Work in Process",
    "Oracle Quoting",
    "Oracle Purchasing",
    "Oracle Quality Application Management",
    "Oracle EBS Supply Chain Management",
    "Oracle Hyperion Data Relationship Management (DRM)",
    "Oracle EBS HCM Compensation Workbench",
    "Oracle Financial Services",
    "Oracle VM",
    "Oracle Exadata Database Machine",
    "Oracle Enterprise Installed Base",
    "Oracle Field Service",
    "Oracle Service Contracts",
    "Oracle Endeca Information Discovery",
    "Oracle Business Intelligence (BI) Publisher",
    "Oracle Fusion Middleware WebLogic Server Admin (WLS)",
    "Data Archiving",
    "Groovy (Programming Language)",
    "Oracle Hyperion Essbase",
    "Oracle Fusion Knowledge Management",
    "Oracle JD Edwards EnterpriseOne Configurable Network Computing (CNC)",
    "Oracle JD Edwards EnterpriseOne Object Management Workbench Development",
    "JDE Development Workbench",
    "Oracle JD Edwards EnterpriseOne Distribution",
    "Oracle JD Edwards EnterpriseOne Financials",
    "Oracle JD Edwards World Interfaces",
    "Oracle JD Edwards EnterpriseOne Manufacturing Management",
    "Oracle JD Edwards EnterpriseOne Project Management",
    "Oracle JD Edwards EnterpriseOne Supply Chain Management (SCM)",
    "Oracle EBS HCM User Productivity Toolkit",
    "Oracle Application Server Web Services",
    "Oracle Data Integrator (ODI)",
    "Oracle Healthcare",
    "Oracle Security",
    "Oracle Technical Architecture",
    "PeopleSoft Administration",
    "PeopleSoft CRM",
    "PeopleSoft Development",
    "PeopleSoft Enterprise Integration",
    "Oracle PeopleSoft ESA Contracts",
    "Oracle PeopleSoft Financials",
    "Oracle PeopleSoft Asset Management",
    "Oracle PeopleSoft Billing",
    "Oracle PeopleSoft Cash Management",
    "Oracle PeopleSoft Expenses",
    "Oracle PeopleSoft General Ledger",
    "Oracle PeopleSoft Grants",
    "Oracle PeopleSoft Financials Order to Cash",
    "Oracle PeopleSoft Payables",
    "Oracle Procure to Pay",
    "Oracle PeopleSoft Receivables",
    "Oracle PeopleSoft Financials Record to Report",
    "Oracle PeopleSoft Financials Treasury",
    "PeopleSoft Human Capital Management (HCM) Global Payroll",
    "PeopleSoft Human Capital Management (HCM) Learning Management",
    "PeopleSoft Integration Broker",
    "PeopleSoft PeopleTools",
    "Oracle PeopleSoft Supply Chain Management (SCM) Customer Order Management",
    "Oracle PeopleSoft Supply Chain Management (SCM) Supply Chain Planning",
    "Oracle PeopleSoft Supplier Relationship Management (SRM) eProcurement",
    "PeopleSoft Strategic Sourcing",
    "PeopleSoft Technical Architecture",
    "PeopleSoft User Security",
    "Oracle PeopleSoft Enterprise Performance Management",
    "Oracle PeopleSoft SCM Inventory & Fulfillment Management",
    "Oracle PeopleSoft Supply Chain Management",
    "Oracle Siebel Configuration",
    "Oracle Siebel Enterprise Application Integration (eAI)",
    "Oracle Siebel Enterprise Integration Management (EIM)",
    "Oracle Siebel Insurance",
    "Oracle Siebel Marketing",
    "Oracle Siebel Product Configurator",
    "Oracle Siebel Sales",
    "Oracle Siebel Service",
    "Oracle Siebel Upgrade",
    "Oracle Demantra",
    "Oracle Communications Policy Management",
    "Oracle Hyperion Financial Data Quality Management Enterprise Edition (FDMEE)",
    "Oracle Siebel Task UI",
    "Oracle GoldenGate",
    "Oracle BRM Functional Configuration",
    "Oracle HCM Cloud Benefits",
    "Oracle HCM Cloud Compensation",
    "Oracle HCM Cloud Core HR",
    "Oracle HCM Cloud Payroll",
    "Oracle Hyperion Technical Architecture",
    "Oracle Smartview",
    "Oracle SOA BPEL Process Manager",
    "Oracle Business Process Management",
    "Oracle SOA OSB",
    "Oracle WebCenter Portal",
    "Oracle Fusion Middleware Enterprise Gateway (OEG)",
    "Oracle Documaker",
    "Oracle R Enterprise",
    "PeopleSoft Human Capital Management (HCM) Absence Management",
    "Oracle Primavera EPPM",
    "Oracle Primavera Unifier",
    "Oracle Cloud Supplier Portal",
    "Oracle SCM Product Lifecycle Management",
    "Oracle SCM Transportation Management",
    "Oracle Master Data Management (MDM) Product Data Hub",
    "PeopleSoft Supplier Relationship Management (SRM) Purchasing",
    "Oracle Product Hub",
    "PeopleSoft Supplier Contract Management",
    "Oracle Engineered Systems",
    "Oracle Database Appliance",
    "Oracle ZFS Storage Appliance",
    "Oracle SCM Advanced Supply Chain Planning (ASCP)",
    "Oracle SCM Demantra Demand Driven Planning",
    "Oracle Siebel Environment Management",
    "Oracle Demantra Demand Management",
    "Oracle HCM Cloud Taleo Connect Client (TCC)",
    "Oracle Endeca Commerce",
    "Siebel Open UI",
    "Oracle PeopleSoft Commitment Control",
    "Oracle HCM Cloud Taleo Onboarding",
    "Oracle Taleo Reporting Business Objects",
    "Oracle JD Edwards EnterpriseOne Procurement",
    "Oracle Java CAPS",
    "Sun Application Server",
    "Sun ONE Directory Server",
    "Oracle SPARC",
    "Oracle StorageTek",
    "Oracle x86",
    "Oracle Cloud Financials Accounting Hub",
    "Oracle Sales Cloud Sales Force Automation",
    "Oracle Enterprise Data Quality",
    "Oracle PeopleSoft Campus Solutions",
    "Oracle Billing and Revenue Management (Oracle BRM)",
    "Oracle Manufacturing Operations Center (MOC)",
    "Oracle JD Edwards World OTC/Logistics",
    "Oracle JD Edwards World Procurement",
    "Oracle EBS Financials",
    "Primavera Web Services",
    "Oracle CPQ Cloud (Big Machines)",
    "Oracle Fusion Middleware Administration",
    "PeopleSoft Fluid User Interface (UI)",
    "Oracle Utilities Customer Care and Billing Financial Management",
    "Oracle Utilities Customer Care and Billing Case Management",
    "Oracle Social Cloud",
    "Oracle Commerce Cloud",
    "Oracle Engagement Cloud - Service",
    "Oracle Inventory Optimization",
    "Oracle PeopleSoft Deal Management",
    "Oracle HCM Cloud Absence/Leave Management",
    "Oracle HCM Cloud Worklife Solutions",
    "Oracle HCM Cloud Social",
    "Oracle HCM Cloud Time & Labor",
    "Oracle Product Lifecycle Management Cloud",
    "Oracle Cloud Order Management",
    "Oracle Cloud Manufacturing",
    "Oracle Cloud Supply Planning",
    "Oracle Cloud Cost Management",
    "Oracle Cloud Warehouse Management",
    "Oracle Demantra Advanced Forecasting",
    "Oracle HCM Cloud Learning",
    "Oracle HCM Cloud BI Reporting and Analytics",
    "Oracle PeopleSoft HCM",
    "Oracle Edge VCP",
    "Oracle Siebel Development",
    "Oracle Sales Cloud Customer Data Management (CDM)",
    "Oracle Cloud Service Analytics",
    "Oracle Data Cloud",
    "Oracle Procurement Cloud",
    "Oracle Cloud Infrastructure Administration",
    "Oracle Database Cloud Services",
    "Oracle Eloqua Marketing Automation",
    "Oracle ADF",
    "Oracle RightNow Cloud Service",
    "Oracle BI Cloud Service",
    "Oracle Database Administration (DBA)",
    "Oracle Integration Cloud Service (ICS)",
    "Oracle Cloud Application Development",
    "Oracle Planning and Budgeting (EPBCS)",
    "Oracle Financial Consolidation and Close (FCC)",
    "Oracle Narrative Reporting",
    "Oracle Profitability and Cost Management (PCMCS)",
    "Oracle Account Reconciliation Cloud Service (ARCS)",
    "Oracle Tax Reporting Cloud (TRCS)",
    "Oracle Enterprise Data Management (EDM)",
    "Oracle Service Cloud Field Service Management",
    "Oracle Financials",
    "Oracle Cloud Financials General Ledger",
    "Oracle Cloud Financials Payables",
    "Oracle Revenue Management",
    "Oracle Cloud Financials Receivables and Collections",
    "Oracle HCM Cloud Talent Management",
    "Oracle Autonomous Database",
    "Oracle Analytics Cloud",
    "Oracle Cloud Order Management Configurator",
    "Oracle Cloud Financials Project Costing",
    "Oracle Policy Administration",
    "Oracle Sales Cloud Incentive Compensation",
    "Oracle HCM Recruiting Cloud",
    "Oracle HCM Cloud Workforce Management",
    "Oracle HCM Cloud Integrations",
    "Oracle Subscription Management Cloud",
    "Oracle Unity Customer Data Platform",
    "Oracle EBS Human Capital Management (HCM)",
    "Oracle NetSuite ERP Financial Management",
    "Oracle NetSuite ERP SCM",
    "Oracle NetSuite SuiteCloud Platform",
    "Oracle JavaScript Extension Toolkit (JET)",
    "Oracle Cloud Visual Builder",
    "Oracle HCM Cloud Workforce Health & Safety",
    "Oracle HCM Cloud HR Helpdesk",
    "Oracle Cloud Inventory Management",
    "Oracle Cloud Conversion",
    "Oracle Cloud Applications Technical",
    "Oracle Digital Assistant Cloud",
    "Oracle DX4C CareX",
    "Oracle DX4C BuyingX",
    "Oracle DX4C LaunchX",
    "Oracle Cloud Channel Revenue Management",
    "Organizational Change Management",
    "Oracle Guided Learning (OGL)",
    "Oracle Cloud EPM Groovy & Business Rules",
    "Oracle Cloud Maintenance",
    "Oracle Cloud Infrastructure (OCI) Gen AI",
    "Oracle Accounting Foundation Cloud Service",
    "Oracle EPM Data Integration",
    "Oracle Cloud Infrastructure (OCI) Generative AI",
    "Oracle Cloud Infrastructure (OCI) Generative AI Agents",
    "Oracle Fusion AI Agent Studio",
  ],
  "Tech_Other":[
    "JavaScript Object Notation (JSON)",
    "Thomson Reuters OneSource Indirect Tax",
    "IBM Informix & Red Brick",
    "IBM Tivoli Monitoring",
    "IBM Rational Team Concert (RTC)",
    "Coaching",
    "Collaboration",
    "Business Process Management Suites (BPMS)",
    "Business Activity Monitoring (BAM) Tools",
    "Business Model Strategy",
    "Language Translation",
    "Business Case Development",
    "Sun Solaris Server Management",
    "Nintex Workflow",
    "Organizational Strategy",
    "Appway",
    "Go Programming Language",
    "Crowdsourcing",
    "IBM Watson Studio",
    "IBM Portal Tools",
    "Marketing Services",
    "HCL AppScan",
    "IBM Content Manager",
    "HCL Unica Campaign",
    "IBM Rational Development and Test Environment for System z",
    "Spring Framework",
    "IBM Urban deploy",
    "Web Content Management",
    "IBM OpenPages",
    "Inclusive Leadership",
    "Ceridian",
    "Configuration Management (CM)",
    "GitLab CI/CD",
    "SMS Marketing",
    "Digital Oscilloscope",
    "Low Speed IO Protocols",
    "High Speed IO Protocols",
    "ANSYS RedHawk",
    "Innovus",
    "Tessent Diagnosis",
    "Bus Analyzer",
    "Universal Asynchronous Receiver-Transmitter",
    "Synopsys Spyglass",
    "Synopsys TetraMAX ATPG",
    "Synopsys PrimeTime PX PTPX",
    "Synopsys PrimeTime",
    "Circuit Compiler ICC2",
    "Unified Power Format",
    "NCSIM Engine",
    "ZeBu Server",
    "Clock Domain Crossing Techniques",
    "SytemVerilog",
    "Register Transfer Level (RTL) Verification",
    "Software Configuration Management (SCM)",
    "Windows Phone BSP/Device Drivers",
    "Circuit Designs",
    "VLSI Design",
    "Electrical Designs",
    "LTspice",
    "Signal Analysis",
    "Signal Generators",
    "Electrical Power Engineering",
    "RTL Design",
    "FPGA Development",
    "ISO 26262",
    "Automation Integration",
    "Power Distribution System Design",
    "Cadence PSpice",
    "OrCAD PSpice",
    "Unified Power Format (UPF)",
    "Electrical Power Design",
    "Integrated Circuit Testers",
    "Design Rules",
    "Analogue Electronics Design",
    "Chip Fabrication",
    "Electromagnetic Compatibility (EMC) Compliance",
    "Hardware Verification",
    "IP Core",
    "Validation Engineering",
    "Chip Design",
    "System on a Chip (SoC)",
    "Electrical Safety",
    "Palladium",
    "Ethernet Networks",
    "Antenna Design",
    "Intellectual Property Investigations",
    "Analog Layout",
    "FPGA Design",
    "Field Programmable Gate Array (FPGA) Programming",
    "ARM Processors",
    "Electrical Principles",
    "Integrated Circuits Design",
    "Application-Specific Integrated Circuit (ASIC) Development",
    "Application Specific Integrated Circuits (ASIC)",
    "Digital Integrated Circuit Design",
    "IEC 61508",
    "Silicon Validation",
    "System on Chip (SoC) Validation",
    "RTL Simulation",
    "Electric VLSI Design System",
    "Communication Interfaces",
    "Electrical Distribution Design",
    "Power Management Integrated Circuits (PMICs)",
    "Memory Development",
    "Mentor Graphics ModelSim",
    "Analog Integrated Circuits",
    "DO-254",
    "RF Signal Generators",
    "Verification Conformal Low Power VCLP",
    "Reset Domain Crossing (RDC)",
    "Phase-Locked Loop (PLL)",
    "IBM Engineering Lifecycle Management IBM ELM",
    "SystemC AMS",
    "Lint",
  ],
  "Tech_Pegasystems":[
    "Appian Process Automation",
    "Pega Marketing",
    "Pega Platform",
    "Pega Robotic Process Automation (RPA)",
    "Pega Architecture",
  ],
  "Tech_Performance Engineering":[
    "Dynatrace APM",
    "Appdynamics APM",
    "IT Performance Optimization",
  ],
  "Tech_Platform Architectures":[
    "Google Maps API",
    "Platform as a Service Providers (PaaS)",
    "Document Management Tools",
    "Enterprise Application Integration (EAI)",
    "OpenEdge ABL",
    "Accenture Rapid Application Workbench",
  ],
  "Tech_Quality Engg":[
    "Functional Test Planning",
    "Automated Testing",
    "Micro Focus Unified Functional Testing (UFT)",
    "Test Management",
    "Worksoft Certify",
    "Agile Testing",
    "Selenium",
    "TOSCA Testsuite",
    "Micro Focus LoadRunner",
    "Neotys NeoLoad",
    "SmartBear TestComplete",
    "TestNG",
    "Test Automation Strategy",
    "Performance Testing Strategy",
    "Broadcom CA DevTest Solution",
    "Web Accessibility",
    "Web Testing",
    "Cucumber (Software)",
    "Apache JMeter",
    "System Integration Testing (SIT)",
    "Web Content Accessibility Guidelines (WCAG)",
    "Katalon Studio",
    "Micro Focus Application Lifecycle Management (ALM) Octane",
    "Cloud Services Test Automation Strategy",
    "Cloud Quality Engineering Strategy",
    "Cloud Resilience Quality Engineering",
    "API Testing",
    "ACCELQ Codeless Test Automation",
  ],
  "Tech_Runtime Architectures":[
    "Model-View-Controller (MVC)",
    "Web Services Standards",
    "webMethods Fabric",
    "Apama",
    "Enterprise Service Bus (ESB)",
    "Message Queue and Broker Performance Tuning",
    "TIBCO Managed File Transfer (MFT)",
    "TIBCO MDM",
  ],
  "Tech_Salesforce":[
    "Heroku",
    "Salesforce Administration",
    "Salesforce Development",
    "Salesforce Testing",
    "Salesforce Technical Architecture",
    "CloudSense",
    "nCino Bank Operating System",
    "Salesforce Sales Cloud",
    "Salesforce Service Cloud",
    "Salesforce Experience Cloud",
    "Salesforce CPQ",
    "Salesforce CRM Analytics",
    "Salesforce Lightning Aura Components",
    "Salesforce Field Service Lightning",
    "Salesforce Industries Communications Cloud",
    "Salesforce Omnistudio Platform",
    "Mulesoft Anypoint Platform",
    "Salesforce Financial Services Cloud",
    "Salesforce Conga CPQ",
    "Salesforce Conga CLM",
    "Salesforce Lightning Web Components",
    "Salesforce Health Cloud",
    "Salesforce CG Cloud Trade Promotion Management Development",
    "Salesforce Industries Manufacturing Cloud",
    "FinancialForce",
    "Salesforce Einstein AI",
    "Salesforce Industries Consumer Goods Cloud",
    "Salesforce Data",
    "Salesforce Automotive Cloud",
    "Salesforce CG Cloud Retail Execution Development",
    "Salesforce CG Cloud Trade Promotion Management Functional",
    "Salesforce CG Cloud Retail Execution Functional",
    "Salesforce DevOps",
    "Salesforce Industries Public Sector Solutions",
    "Salesforce Revenue Cloud",
  ],
  "Tech_SAP":[
    "SAP Callidus Configuration and Development",
    "SAP Bank Analyzer",
    "SAP for Banking Deposits Management",
    "SAP CRM Sales",
    "SAP HCM Time Management",
    "SAP HCM Personnel Administration",
    "SAP HCM Payroll",
    "SAP SRM",
    "SAP Concur",
    "SAP Business Suite Testing",
    "SAP Sustainability Control Tower SCT",
    "SAP Global Trade Services",
    "SAP EWM",
    "SAP ABAP CRM",
    "SAP Basis Administration",
    "SAP Data Services Development",
    "SAP Field Service Management",
    "SAP S/4HANA for Product Compliance",
    "SAP FSCM Credit Management",
    "Accenture HCM Audit and Compliance Software",
    "SAP Information Lifecycle management ILM",
    "SAP BTP Mobile Application Development",
    "SAP Monitoring & Tools",
    "SAP ABAP Object Oriented Development",
    "SAP PO/PI & APIs Development",
    "SAP TM Transportation Management",
    "SAP Native HANA SQL Modeling & Development",
    "SAP SuccessFactors Compensation",
    "SAP SuccessFactors Employee Central",
    "SAP SuccessFactors Learning",
    "SAP SuccessFactors Performance & Goals",
    "SAP SuccessFactors Recruiting",
    "SAP SCM APO Advanced Planning & Optimization",
    "SAP Plant Maintenance (PM)",
    "SAP Project System (PS)",
    "SAP HANA DB Administration",
    "SAP Ariba",
    "SAP FSCM Treasury and Risk Management (TRM)",
    "SAP MM Materials Management",
    "SAP UI5 Development",
    "SAP ABAP Development for HANA",
    "SAP HANA Technical Architecture",
    "SAP CX Sales Cloud C4C",
    "SAP Vendor Invoice Management",
    "Syniti ADM for SAP",
    "SAP MM AFS Apparel & Footwear",
    "SAP BusinessObjects Financial Consolidation",
    "SAP CO Management Accounting",
    "SAP HCM On Premise ABAP",
    "SAP Enterprise Portal Architecture",
    "SAP FIORI/Gateway architecture",
    "SAP Identity and Access Management",
    "SAP SLO Upgrades & Migrations",
    "SAP Master Data Migration",
    "SAP BTP Integration Suite",
    "SAP Successfactors Integrations Technical",
    "SAP Governance Risk and Compliance (SAP GRC)",
    "SAP FI CO Finance",
    "SAP for Insurance",
    "SAP SuccessFactors Employee Central Payroll",
    "SAP PP Production Planning & Control Discrete Industries",
    "SAP Quality Management (QM)",
    "SAP FI S/4HANA Accounting",
    "SAP Vistex",
    "SAP C4C SDK and PDI",
    "SAP BRIM Convergent Invoicing CI",
    "SAP CX Service Cloud C4C",
    "SAP for Insurance Policy Management (FS-PM)",
    "SAP Product Lifecycle Management",
    "SAP Portfolio and Project Management",
    "SAP S/4HANA Security",
    "SAP Configure Price & Quote",
    "SAP BRIM Convergent Charging (CC)",
    "SAP BRIM Convergent Mediation (CM)",
    "SAP BRIM Contract Accounting FI-CA",
    "SAP Flexible Real Estate Management (RE-FX)",
    "SAP SuccessFactors Conversion",
    "SAP Master Data Governance MDG Tool",
    "SAP BusinessObjects Data Services",
    "SAP Fieldglass Contingent Workforce",
    "SAP FI S/4HANA Central Finance",
    "SAP BW/4HANA Data Modeling & Development",
    "SAP Analytics Cloud Development",
    "SAP Profitability & Performance Mgt PaPM",
    "SAP Financial Products Subledger (FPSL)",
    "SAP Sales and Distribution (SD)",
    "SAP Manufacturing Integration & Intelligence (MII)",
    "Sybase Database",
    "SAP BusinessObjects Business Intelligence",
    "SAP Customer Data Cloud",
    "SAP S/4HANA Group Reporting",
    "SAP Security Cloud Applications",
    "SAP BRIM Subscription Order Management SOM",
    "SAP BTP Application Development",
    "SAP BTP Administration",
    "SAP Intelligent Asset Management",
    "SAP Emarsys Customer Engagement",
    "SAP Ariba Cloud Integration Gateway (CIG)",
    "SAP S/4HANA Cloud Public Edition",
    "DevOps for SAP",
    "SAP ABAP Cloud",
    "SAP S/4HANA Embedded Production Planning and Detailed Scheduling (EPPDS)",
    "SAP S/4HANA Extended Service Parts Planning (ESPP)",
    "SAP CPI for Data Services",
    "Insightsoftware SourceConnect",
    "SAP Analytics Cloud Planning",
    "SAP S/4HANA Advanced Available to Promise",
    "SAP Build Process Automation",
    "SAP S/4HANA Cloud Public Finance",
    "SAP S/4HANA Cloud Public Manufacturing",
    "SAP S/4HANA Cloud Public Src & Proc",
    "SAP S/4HANA Cloud Public Professional Services",
    "SAP S/4HANA Cloud Public Supply Chain",
    "SAP S/4HANA Cloud Public Service",
    "SAP S/4HANA Cloud Public Sales",
    "SAP S/4HANA Cloud Public Warehouse Mgmt",
    "SAP S/4HANA Cloud Public Asset Mgmt",
    "SAP S/4HANA Cloud Public Activate",
    "SAP Document and Reporting Compliance",
    "SAP SuccessFactors Time Management",
    "SAP BTP Datasphere",
    "SAP Generative AI",
    "SAP Customer Data Platform",
    "SAP SuccessFactors Onboarding",
    "SAP Integrated Business Planning (IBP)",
    "SAP Advanced Manufacturing",
    "Syniti ADMM for SAP",
    "SAP Gen AI Hub",
    "SAP SuccessFactors People Analytics",
    "SAP Activate",
    "SAP Entitlement Management System EMS",
    "SAP Cloud Application Lifecycle Management (ALM)",
    "SAP Revenue Accounting and Reporting ERP",
    "SAP SuccessFactors Variable Pay",
    "SAP Business Data Cloud (BDC)",
  ],
  "Tech_Silicon Engg":[
    "Electronic Design Automation (EDA)",
    "Bare Metal Programming",
    "Universal Verification Methodology (UVM)",
    "Automatic Test Pattern Generation (ATPG)",
    "Joint Test Action Group (JTAG)",
    "Memory Built-In Self Test (MBIST)",
    "Layout Versus Schematic (LVS)",
    "Design Rule Checking (DRC)",
    "Gate Level Simulation",
    "Static Timing Analysis (STA)",
    "Verilog",
    "Physical Design",
    "SPICE Simulations",
    "Design for Testability (DFT)",
    "RTL Coding",
    "Software Architectures",
    "SoC Integration",
    "SoC Verification",
    "Design Synthesis",
    "Power Analysis",
    "Emulation",
    "FPGA Prototyping",
    "Lauterbach TRACE32",
    "Post Silicon Validation",
    "Integrated Circuit Layout",
    "Design Verification Testing",
    "Cadence Virtuoso",
    "Formal Verification",
    "Physical Verification",
    "VLSI CAD",
    "Analog Layout Design",
    "Analog Circuits Design",
    "Memory Design",
    "Low-Power Design",
    "Scan Chain",
    "Microarchitecture",
    "Testbench Architecture",
    "Floorplanning",
    "Power Planning",
    "Analog Signal Processing",
    "Noise Analysis",
    "Device Driver Development",
  ],
  "Tech_Software as a Service":[
    "Zuora",
    "Xactly Incent",
  ],
  "Tech_Song":[
    "Oracle ATG Web Commerce",
    "HCL Commerce",
    "HCL Unica",
    "Alfresco",
    "Drupal",
    "Salesforce B2C Commerce",
    "Customer Data Platform & Integration",
    "OpenText Documentum",
    "OpenText ECM Tools",
    "Backbone.js",
    "Apache Solr",
    "Elastic Path",
    "Vue.js",
    "Swift Programming Language",
    "Advance Front End Development NodeJs",
    "Multiplatform Front End Development React",
    "Multiplatform Front End Development Angular",
    "Kotlin Programming Language",
    "React Native",
    "SAS Campaign Management",
    "User Experience (UX) Design",
    "Multiplatform Application Development",
    "Extended Reality XR Application Development",
    "Liferay Digital Experience Platform (DXP)",
    "IBM FileNet ECM Tools",
    "Mobile Architecture",
    "Mobile Performance Testing",
    "Android Application Development",
    "Apple iOS Application Development",
    "Mobile and Tablet Applications Testing",
    "Mobile Device/App Automation Testing",
    "Web Application Development",
    "SAP Hybris Commerce",
    "SnapLogic",
    "Mobile Application Security",
    "Digital Commerce Platforms",
    "Salesforce B2B Commerce for Visualforce",
    "Enterprise Content Management Implementation",
    "eCommerce Frameworks Implementation",
    "User Interface Development",
    "User Experience Research Tools and Techniques",
    "Visual Design and Development",
    "Campaign Analytics & Reporting",
    "Extended Reality Content Development",
    "Flutter Software Development Kit (SDK)",
    "Salesforce Marketing Cloud",
    "Salesforce Commerce Cloud",
    "Digital Full Stack Development",
    "Progressive Web Application Framework",
    "OpenText Enterprise Information Management (EIM)",
    "Akeneo Product Information Management",
    "OutSystems",
    "Unqork Enterprise Application Platform",
    "Salesforce Marketing Cloud Personalization",
    "Customer Communication Management Solutions",
    "Salesforce B2B Commerce",
    "CommerceTools Commerce Platform",
    "Fluent Commerce Order Management Functional",
    "Fluent Commerce Order Management Technical",
    "Salesforce Marketing Cloud Customer Data Platform",
    "Aprimo Digital Asset Management (DAM)",
    "Lytics Customer Data Platform",
    "Mirakl Marketplace Commerce Platform",
    "Shopify eCommerce Platform",
    "Algolia (Search Platform)",
    "Adyen (Payment Platform)",
    "Marketplacer Marketplace Commerce Platform",
    "Redpoint Customer Data Platform",
    "Stripe (Payment Platform)",
    "Tealium AudienceStream",
    "Tealium iQ",
    "Twilio Segment Customer Engagement Platform",
    "VTEX Platform",
    "GraphQL (Query Language)",
    "Lucidworks Fusion",
    "InRiver Product Information Management",
    "Salsify Product Experience Management Platform",
    "Syndigo Platform",
    "Genesys Cloud AI",
    "Genesys Cloud CX",
    "Genesys Cloud WFM",
    "Genesys Contact Center QM",
    "Genesys Voice Platform",
    "Sprinklr",
    "Salesforce Order Management",
    "SAP Spartacus Composable Storefront",
  ],
  "Tech_Talent&Transformation":[
    "Learning Delivery Instruction",
    "Design Thinking",
    "Storytelling",
  ],
  "Tech_Workday":[
    "Workday Financial Accounting Core",
    "Workday Data Mapping & Conversions",
    "Workday Talent Management",
    "Workday Benefits",
    "Workday Core Compensation",
    "Workday HCM Security",
    "Workday Recruiting",
    "Workday Core Integrations",
    "Workday Core HCM",
    "Workday US Payroll",
    "Workday Canadian Payroll",
    "Workday UK Payroll",
    "Workday Cloud Connect For Benefits",
    "Workday Cloud Connect for Third Party Payroll",
    "Workday Studio",
    "Workday Composite Reporting",
    "Workday Project Management (PM)",
    "Workday Learning",
    "Workday Advanced Compensation",
    "Workday Financial Integration",
    "Workday US Time Tracking",
    "Workday US Absence Management",
    "Workday Report Designer (BIRT)",
    "Workday HCM Testing",
    "Workday Medium Enterprise Deployment",
    "Workday Big Data Analytics",
    "Workday Prism Analytics",
    "Workday Extend",
    "Workday Advanced Reporting",
    "Adaptive Insight",
    "Workday Grants Management",
    "Workday Strategic Sourcing",
    "Workday Banking & Settlement",
    "Workday Business Assets",
    "Workday Endowments",
    "Workday Expenses",
    "Workday Inventory",
    "Workday Planning",
    "Workday Procurement",
    "Workday Projects",
    "Workday Revenue Management",
    "Workday Supplier Management",
    "Workday Projects Billing",
    "Workday Adaptive Integrations",
    "Workday Accounting Center",
    "Workday Payroll France",
    "Workday EIB Data Load",
    "Workday Academic Foundation",
    "Workday Student Admissions",
    "Workday Student Financials Foundation and Business Processes",
    "Workday Student Records",
    "Workday Student Recruiting",
    "Workday Academic Advising",
    "Workday Student Security",
    "Workday Student Reporting",
    "Workday Foundation Data Model (FDM)",
    "Workday Peakon Employee Voice",
    "Workday People Analytics",
    "Workday People Experience",
    "Workday Orchestrate",
    "Workday Scheduling & Labor Optimization",
    "Workday Australia Payroll",
  ]
};